import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
class UserDataObjectType_Property_PropertyType {
  get descriptor() {
    return UserDataObjectType_Property_PropertyType.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._propertyDataTypeCase = 0;
    this._propertyDataTypeValue = null;
  }
  isEmpty() {
    if (this._propertyDataTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataObjectType_Property_PropertyType) {
      return value;
    }
    return UserDataObjectType_Property_PropertyType.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataObjectType_Property_PropertyType();
    if (json.primitiveType != null) {
      result._propertyDataTypeCase = 1;
      result._propertyDataTypeValue = UserDataObjectType_Property_PrimitiveType.fromJson(json.primitiveType);
    }
    if (json.customType != null) {
      result._propertyDataTypeCase = 2;
      result._propertyDataTypeValue = UserDataObjectType.fromJson(json.customType);
    }
    if (json.referencingUserDataType != null) {
      result._propertyDataTypeCase = 3;
      result._propertyDataTypeValue = JsonToString.fromJson(json.referencingUserDataType);
    }
    if (json.referencingType != null) {
      result._propertyDataTypeCase = 4;
      result._propertyDataTypeValue = UserDataObjectType_Property_ReferencingType.fromJson(json.referencingType);
    }
    if (json.listOfReferencingUserDataType != null) {
      result._propertyDataTypeCase = 5;
      result._propertyDataTypeValue = JsonToString.fromJson(json.listOfReferencingUserDataType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._propertyDataTypeCase) {
      case 1:
        result.primitiveType = UserDataObjectType_Property_PrimitiveType.toJson(this._propertyDataTypeValue);
        break;
      case 2:
        result.customType = UserDataObjectType.toJson(this._propertyDataTypeValue);
        break;
      case 3:
        result.referencingUserDataType = JsonToString.toJson(this._propertyDataTypeValue);
        break;
      case 4:
        result.referencingType = UserDataObjectType_Property_ReferencingType.toJson(this._propertyDataTypeValue);
        break;
      case 5:
        result.listOfReferencingUserDataType = JsonToString.toJson(this._propertyDataTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get propertyDataTypeCase() {
    return this._propertyDataTypeCase;
  }
  deletePropertyDataType(path) {
    switch (this._propertyDataTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['primitiveType'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['customType'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['referencingUserDataType'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['referencingType'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['listOfReferencingUserDataType'])};
      }
    }
  }
  /**
   * @returns {number}
   */
  get primitiveType() {
    return this._propertyDataTypeCase === 1 ? this._propertyDataTypeValue : UserDataObjectType_Property_PrimitiveType.default;
  }
  setPrimitiveType(path, value) {
    return {type: 'SET', path: path.concat(['primitiveType']), value};
  }
  deletePrimitiveType(path) {
    return {type: 'DELETE', path: path.concat(['primitiveType'])};
  }
  /**
   * @returns {UserDataObjectType}
   */
  get customType() {
    return this._propertyDataTypeCase === 2 ? this._propertyDataTypeValue : UserDataObjectType.default;
  }
  setCustomType(path, value) {
    return {type: 'SET', path: path.concat(['customType']), value: value.toJson()};
  }
  deleteCustomType(path) {
    return {type: 'DELETE', path: path.concat(['customType'])};
  }
  /**
   * @returns {string}
   */
  get referencingUserDataType() {
    return this._propertyDataTypeCase === 3 ? this._propertyDataTypeValue : JsonToString.default;
  }
  setReferencingUserDataType(path, value) {
    return {type: 'SET', path: path.concat(['referencingUserDataType']), value};
  }
  deleteReferencingUserDataType(path) {
    return {type: 'DELETE', path: path.concat(['referencingUserDataType'])};
  }
  /**
   * @returns {number}
   */
  get referencingType() {
    return this._propertyDataTypeCase === 4 ? this._propertyDataTypeValue : UserDataObjectType_Property_ReferencingType.default;
  }
  setReferencingType(path, value) {
    return {type: 'SET', path: path.concat(['referencingType']), value};
  }
  deleteReferencingType(path) {
    return {type: 'DELETE', path: path.concat(['referencingType'])};
  }
  /**
   * @returns {string}
   */
  get listOfReferencingUserDataType() {
    return this._propertyDataTypeCase === 5 ? this._propertyDataTypeValue : JsonToString.default;
  }
  setListOfReferencingUserDataType(path, value) {
    return {type: 'SET', path: path.concat(['listOfReferencingUserDataType']), value};
  }
  deleteListOfReferencingUserDataType(path) {
    return {type: 'DELETE', path: path.concat(['listOfReferencingUserDataType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "primitiveType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 1;
              copy._propertyDataTypeValue = UserDataObjectType_Property_PrimitiveType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._propertyDataTypeCase !== 1) {
                return this;
              }
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 0;
              copy._propertyDataTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "customType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 2;
              copy._propertyDataTypeValue = UserDataObjectType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._propertyDataTypeCase !== 2) {
                return this;
              }
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 0;
              copy._propertyDataTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._propertyDataTypeCase !== 2) {
            const copy = new UserDataObjectType_Property_PropertyType(this);
            copy._propertyDataTypeCase = 2;
            copy._propertyDataTypeValue = UserDataObjectType.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.customType.apply(type, path.slice(1), value);
          if (newValue === this.customType) {
            return this;
          }
          const copy = new UserDataObjectType_Property_PropertyType(this);
          copy._propertyDataTypeCase = 2;
          copy._propertyDataTypeValue = newValue;
          return copy;
        }
      }
      case "referencingUserDataType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 3;
              copy._propertyDataTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._propertyDataTypeCase !== 3) {
                return this;
              }
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 0;
              copy._propertyDataTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "referencingType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 4;
              copy._propertyDataTypeValue = UserDataObjectType_Property_ReferencingType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._propertyDataTypeCase !== 4) {
                return this;
              }
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 0;
              copy._propertyDataTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "listOfReferencingUserDataType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 5;
              copy._propertyDataTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._propertyDataTypeCase !== 5) {
                return this;
              }
              const copy = new UserDataObjectType_Property_PropertyType(this);
              copy._propertyDataTypeCase = 0;
              copy._propertyDataTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataObjectType_Property_PropertyType} other
   * @returns {UserDataObjectType_Property_PropertyType}
   */
  merge(other) {
    const copy = new UserDataObjectType_Property_PropertyType(this);
    if (other._propertyDataTypeCase === 1) {
      copy._propertyDataTypeCase = 1;
      copy._propertyDataTypeValue = other._propertyDataTypeValue;
    }
    if (other._propertyDataTypeCase === 1) {
      if (this._propertyDataTypeCase === 1) {
        copy._propertyDataTypeValue = copy._propertyDataTypeValue.merge(other._propertyDataTypeValue);
      } else {
        copy._propertyDataTypeValue = other._propertyDataTypeValue;
      }
      copy._propertyDataTypeCase = 1;
    }
    if (other._propertyDataTypeCase === 1) {
      copy._propertyDataTypeCase = 1;
      copy._propertyDataTypeValue = other._propertyDataTypeValue;
    }
    if (other._propertyDataTypeCase === 1) {
      copy._propertyDataTypeCase = 1;
      copy._propertyDataTypeValue = other._propertyDataTypeValue;
    }
    if (other._propertyDataTypeCase === 1) {
      copy._propertyDataTypeCase = 1;
      copy._propertyDataTypeValue = other._propertyDataTypeValue;
    }
    return copy;
  }
}
UserDataObjectType_Property_PropertyType.default = new UserDataObjectType_Property_PropertyType();
class UserDataObjectType_Property_PropertyType_Builder {
  constructor(value) {
    this._value = new UserDataObjectType_Property_PropertyType(value);
  }
  build() {
    return new UserDataObjectType_Property_PropertyType(this._value);
  }
  clearpropertyDataType() {
    this._value._propertyDataTypeCase = 0;
    this._value._propertyDataTypeValue = null;
    return this;
  }
  setPrimitiveType(value) {
    this._value._propertyDataTypeCase = 1;
    this._value._propertyDataTypeValue = value;
    return this;
  }
  setCustomType(value) {
    this._value._propertyDataTypeCase = 2;
    this._value._propertyDataTypeValue = value;
    return this;
  }
  setReferencingUserDataType(value) {
    this._value._propertyDataTypeCase = 3;
    this._value._propertyDataTypeValue = value;
    return this;
  }
  setReferencingType(value) {
    this._value._propertyDataTypeCase = 4;
    this._value._propertyDataTypeValue = value;
    return this;
  }
  setListOfReferencingUserDataType(value) {
    this._value._propertyDataTypeCase = 5;
    this._value._propertyDataTypeValue = value;
    return this;
  }
}
UserDataObjectType_Property_PropertyType.Builder = UserDataObjectType_Property_PropertyType_Builder;
class UserDataObjectType_Property_PropertyType_WithParent {
  /**
   * @param {UserDataObjectType_Property_PropertyType} value
   * @param {UserDataObjectType_Property_PropertyType_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataObjectType_Property_PropertyType.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get propertyDataTypeCase() {
    if (this._cachedpropertyDataTypeCase === undefined) {
      if (this._value._propertyDataTypeCase === 0) {
        this._cachedpropertyDataTypeCase = this._parent ? this._parent.propertyDataTypeCase : 0;
      } else {
        this._cachedpropertyDataTypeCase = this._value._propertyDataTypeCase;
      }
    }
    return this._cachedpropertyDataTypeCase;
  }
  get primitiveType() {
    if (!this._cachedPrimitiveType) {
      if (this._value._propertyDataTypeCase === 0) {
        this._cachedPrimitiveType = this._parent ? this._parent.primitiveType : this._value.primitiveType;
      } else {
        this._cachedPrimitiveType = this._value.primitiveType;
      }
    }
    return this._cachedPrimitiveType;
  }
  get customType() {
    if (!this._cachedCustomType) {
      if (this._value._propertyDataTypeCase === 0) {
        this._cachedCustomType = this._parent ? new UserDataObjectType.WithParent(UserDataObjectType.default, this._parent.customType) : this._value.customType;
      } else if (this._value._propertyDataTypeCase === 2) {
        this._cachedCustomType = new UserDataObjectType.WithParent(this._value.customType, this._parent && this._parent.propertyDataTypeCase === 2 ? this._parent.customType : null);
      } else {
        this._cachedCustomType = UserDataObjectType.WithParent.default;
      }
    }
    return this._cachedCustomType;
  }
  get referencingUserDataType() {
    if (!this._cachedReferencingUserDataType) {
      if (this._value._propertyDataTypeCase === 0) {
        this._cachedReferencingUserDataType = this._parent ? this._parent.referencingUserDataType : this._value.referencingUserDataType;
      } else {
        this._cachedReferencingUserDataType = this._value.referencingUserDataType;
      }
    }
    return this._cachedReferencingUserDataType;
  }
  get referencingType() {
    if (!this._cachedReferencingType) {
      if (this._value._propertyDataTypeCase === 0) {
        this._cachedReferencingType = this._parent ? this._parent.referencingType : this._value.referencingType;
      } else {
        this._cachedReferencingType = this._value.referencingType;
      }
    }
    return this._cachedReferencingType;
  }
  get listOfReferencingUserDataType() {
    if (!this._cachedListOfReferencingUserDataType) {
      if (this._value._propertyDataTypeCase === 0) {
        this._cachedListOfReferencingUserDataType = this._parent ? this._parent.listOfReferencingUserDataType : this._value.listOfReferencingUserDataType;
      } else {
        this._cachedListOfReferencingUserDataType = this._value.listOfReferencingUserDataType;
      }
    }
    return this._cachedListOfReferencingUserDataType;
  }
  update(current, parent) {
    const result = new UserDataObjectType_Property_PropertyType_WithParent(current, parent);
    if (this._cachedCustomType && this._value._propertyDataTypeCase === 2 && current._propertyDataTypeCase === 2) {
      if (this._value.customType === current.customType && this._parent === parent) {
        result._cachedCustomType = this._cachedCustomType;
      } else {
        result._cachedCustomType = this._cachedCustomType.update(current.customType, parent && parent.propertyDataTypeCase === 2 ? parent.customType : null);
      }
    }
    return result;
  }
}
UserDataObjectType_Property_PropertyType_WithParent.default = new UserDataObjectType_Property_PropertyType_WithParent(UserDataObjectType_Property_PropertyType.default, null);
UserDataObjectType_Property_PropertyType.WithParent = UserDataObjectType_Property_PropertyType_WithParent;
class UserDataObjectType_Property_PropertyType_Descriptor {
  get primitiveType() {
    if (!this._primitiveType) {
      this._primitiveType = {
        name: "primitiveType",
        Name: "PrimitiveType",
        number: 1,
        protoType: 14,
        protoName: "primitive_type",
        oneofIndex: 0,
        type: UserDataObjectType_Property_PrimitiveType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._primitiveType;
  }
  get customType() {
    if (!this._customType) {
      this._customType = {
        name: "customType",
        Name: "CustomType",
        number: 2,
        protoType: 11,
        protoName: "custom_type",
        oneofIndex: 0,
        type: UserDataObjectType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._customType;
  }
  get referencingUserDataType() {
    if (!this._referencingUserDataType) {
      this._referencingUserDataType = {
        name: "referencingUserDataType",
        Name: "ReferencingUserDataType",
        number: 3,
        protoType: 9,
        protoName: "referencing_user_data_type",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._referencingUserDataType;
  }
  get referencingType() {
    if (!this._referencingType) {
      this._referencingType = {
        name: "referencingType",
        Name: "ReferencingType",
        number: 4,
        protoType: 14,
        protoName: "referencing_type",
        oneofIndex: 0,
        type: UserDataObjectType_Property_ReferencingType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._referencingType;
  }
  get listOfReferencingUserDataType() {
    if (!this._listOfReferencingUserDataType) {
      this._listOfReferencingUserDataType = {
        name: "listOfReferencingUserDataType",
        Name: "ListOfReferencingUserDataType",
        number: 5,
        protoType: 9,
        protoName: "list_of_referencing_user_data_type",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._listOfReferencingUserDataType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.primitiveType,
        this.customType,
        this.referencingUserDataType,
        this.referencingType,
        this.listOfReferencingUserDataType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "propertyDataType",
        Name: "PropertyDataType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataObjectType_Property_PropertyType.descriptor = new UserDataObjectType_Property_PropertyType_Descriptor();
class UserDataObjectType_Property_PrimitiveType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NUMBER": return 0;
        case "STRING": return 1;
        case "BOOLEAN": return 2;
        case "LIST_OF_NUMBERS": return 3;
        case "LIST_OF_STRINGS": return 4;
        case "LIST_OF_BOOLEANS": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return UserDataObjectType_Property_PrimitiveType.fromJson(value);
  }
  static fromReact(e) {
    return UserDataObjectType_Property_PrimitiveType.fromJson(e);
  }
}
UserDataObjectType_Property_PrimitiveType.NUMBER = 0;
UserDataObjectType_Property_PrimitiveType.STRING = 1;
UserDataObjectType_Property_PrimitiveType.BOOLEAN = 2;
UserDataObjectType_Property_PrimitiveType.LIST_OF_NUMBERS = 3;
UserDataObjectType_Property_PrimitiveType.LIST_OF_STRINGS = 4;
UserDataObjectType_Property_PrimitiveType.LIST_OF_BOOLEANS = 5;
UserDataObjectType_Property_PrimitiveType.default = 0;
UserDataObjectType_Property_PrimitiveType.values = {
  NUMBER: 0,
  STRING: 1,
  BOOLEAN: 2,
  LIST_OF_NUMBERS: 3,
  LIST_OF_STRINGS: 4,
  LIST_OF_BOOLEANS: 5,
};
UserDataObjectType_Property_PrimitiveType.names = {
  0: "NUMBER",
  1: "STRING",
  2: "BOOLEAN",
  3: "LIST_OF_NUMBERS",
  4: "LIST_OF_STRINGS",
  5: "LIST_OF_BOOLEANS",
};
class UserDataObjectType_Property_ReferencingType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "ACTOR": return 0;
        case "BEHAVIOR": return 1;
        case "EFFECT": return 2;
        case "WEAPON": return 3;
        case "UNIT": return 4;
        case "UI": return 5;
        case "LOCALIZATION": return 6;
        case "ASSET": return 7;
        case "REFERENCING_VALUE": return 8;
        case "ABILITY": return 9;
        case "COLOR": return 10;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return UserDataObjectType_Property_ReferencingType.fromJson(value);
  }
  static fromReact(e) {
    return UserDataObjectType_Property_ReferencingType.fromJson(e);
  }
}
UserDataObjectType_Property_ReferencingType.ACTOR = 0;
UserDataObjectType_Property_ReferencingType.BEHAVIOR = 1;
UserDataObjectType_Property_ReferencingType.EFFECT = 2;
UserDataObjectType_Property_ReferencingType.WEAPON = 3;
UserDataObjectType_Property_ReferencingType.UNIT = 4;
UserDataObjectType_Property_ReferencingType.UI = 5;
UserDataObjectType_Property_ReferencingType.LOCALIZATION = 6;
UserDataObjectType_Property_ReferencingType.ASSET = 7;
UserDataObjectType_Property_ReferencingType.REFERENCING_VALUE = 8;
UserDataObjectType_Property_ReferencingType.ABILITY = 9;
UserDataObjectType_Property_ReferencingType.COLOR = 10;
UserDataObjectType_Property_ReferencingType.default = 0;
UserDataObjectType_Property_ReferencingType.values = {
  ACTOR: 0,
  BEHAVIOR: 1,
  EFFECT: 2,
  WEAPON: 3,
  UNIT: 4,
  UI: 5,
  LOCALIZATION: 6,
  ASSET: 7,
  REFERENCING_VALUE: 8,
  ABILITY: 9,
  COLOR: 10,
};
UserDataObjectType_Property_ReferencingType.names = {
  0: "ACTOR",
  1: "BEHAVIOR",
  2: "EFFECT",
  3: "WEAPON",
  4: "UNIT",
  5: "UI",
  6: "LOCALIZATION",
  7: "ASSET",
  8: "REFERENCING_VALUE",
  9: "ABILITY",
  10: "COLOR",
};
class UserDataObjectType_Property {
  get descriptor() {
    return UserDataObjectType_Property.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasType = false;
    this._type = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasType && !this._type.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataObjectType_Property) {
      return value;
    }
    return UserDataObjectType_Property.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataObjectType_Property();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.type != null) {
      result._hasType = true;
      result._type = UserDataObjectType_Property_PropertyType.fromJson(json.type);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasType && !this._type.isEmpty()) {
      result.type = UserDataObjectType_Property_PropertyType.toJson(this._type);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {UserDataObjectType_Property_PropertyType}
   */
  get type() {
    return this._hasType ? this._type : UserDataObjectType_Property_PropertyType.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value: value.toJson()};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType_Property(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new UserDataObjectType_Property(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType_Property(this);
              copy._hasType = true;
              copy._type = UserDataObjectType_Property_PropertyType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new UserDataObjectType_Property(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasType) {
            const copy = new UserDataObjectType_Property(this);
            copy._hasType = true;
            copy._type = UserDataObjectType_Property_PropertyType.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._type.apply(type, path.slice(1), value);
          if (newValue === this._type) {
            return this;
          }
          const copy = new UserDataObjectType_Property(this);
          copy._type = copy._type.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataObjectType_Property} other
   * @returns {UserDataObjectType_Property}
   */
  merge(other) {
    const copy = new UserDataObjectType_Property(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasType) {
      if (copy._hasType) {
        copy._type = copy.type.merge(other.type);
      } else {
        copy._type = other._type;
      }
      copy._hasType = true;
    }
    return copy;
  }
}
UserDataObjectType_Property.default = new UserDataObjectType_Property();
UserDataObjectType_Property.PropertyType = UserDataObjectType_Property_PropertyType;
UserDataObjectType_Property.PrimitiveType = UserDataObjectType_Property_PrimitiveType;
UserDataObjectType_Property.ReferencingType = UserDataObjectType_Property_ReferencingType;
class UserDataObjectType_Property_Builder {
  constructor(value) {
    this._value = new UserDataObjectType_Property(value);
  }
  build() {
    return new UserDataObjectType_Property(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
}
UserDataObjectType_Property.Builder = UserDataObjectType_Property_Builder;
class UserDataObjectType_Property_WithParent {
  /**
   * @param {UserDataObjectType_Property} value
   * @param {UserDataObjectType_Property_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataObjectType_Property.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (!this._cachedType) {
      if (this._value.hasType) {
        this._cachedType = new UserDataObjectType_Property_PropertyType.WithParent(this._value.type, this._parent && this._parent.hasType ? this._parent.type : null);
      } else {
        this._cachedType = this._parent ? new UserDataObjectType_Property_PropertyType.WithParent(UserDataObjectType_Property_PropertyType.default, this._parent.type) : UserDataObjectType_Property_PropertyType.WithParent.default;
      }
    }
    return this._cachedType;
  }
  update(current, parent) {
    const result = new UserDataObjectType_Property_WithParent(current, parent);
    if (this._cachedType && this._value.hasType && current.hasType) {
      if (this._value.type === current.type && this._parent === parent) {
        result._cachedType = this._cachedType;
      } else {
        result._cachedType = this._cachedType.update(current.type, parent && parent.hasType ? parent.type : null);
      }
    }
    return result;
  }
}
UserDataObjectType_Property_WithParent.default = new UserDataObjectType_Property_WithParent(UserDataObjectType_Property.default, null);
UserDataObjectType_Property.WithParent = UserDataObjectType_Property_WithParent;
class UserDataObjectType_Property_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 2,
        protoType: 11,
        protoName: "type",
        type: UserDataObjectType_Property_PropertyType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.type,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataObjectType_Property.descriptor = new UserDataObjectType_Property_Descriptor();
export class UserDataObjectType {
  get descriptor() {
    return UserDataObjectType.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._properties = [];
    this._hasComment = false;
    this._comment = null;
  }
  isEmpty() {
    if (this._properties.length > 0) return false;
    if (this._hasComment) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataObjectType) {
      return value;
    }
    return UserDataObjectType.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataObjectType();
    result._properties = JsonToList(json.properties, UserDataObjectType_Property);
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._properties.length > 0) {
      result.properties = ArrayToJson(this._properties, UserDataObjectType_Property);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    return result;
  }
  /**
   * @returns {UserDataObjectType_Property[]}
   */
  get properties() {
    return this._properties;
  }
  addProperties(path, value) {
    return {type: 'ADD', path: path.concat(['properties']), value: value.toJson()};
  }
  setProperties(path, value) {
    return {type: 'SET', path: path.concat(['properties']), value: ArrayToJson(value, UserDataObjectType_Property)};
  }
  setPropertiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['properties', key]), value: value.toJson()};
  }
  deleteProperties(path) {
    return {type: 'DELETE', path: path.concat(['properties'])};
  }
  deletePropertiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['properties', key])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "properties": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType(this);
              copy._properties = [];        for (let i of value) {
                copy._properties.push(UserDataObjectType_Property.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UserDataObjectType(this);
              copy._properties = copy._properties.concat([UserDataObjectType_Property.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._properties.length === 0) {
                return this;
              }
              const copy = new UserDataObjectType(this);
              copy._properties = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._properties.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType(this);
              copy._properties = copy._properties.slice();
              copy._properties[path[1]] = UserDataObjectType_Property.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UserDataObjectType(this);
              copy._properties = copy._properties.slice(0, path[1]).concat(copy._properties.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._properties.length) {
            return this;
          }
          const oldValue = this._properties[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserDataObjectType(this);
          copy._properties = copy._properties.slice();
          copy._properties[key] = newValue;
          return copy;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataObjectType(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new UserDataObjectType(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataObjectType} other
   * @returns {UserDataObjectType}
   */
  merge(other) {
    const copy = new UserDataObjectType(this);
    copy._properties = this._properties.concat(other._properties);
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    return copy;
  }
}
UserDataObjectType.default = new UserDataObjectType();
UserDataObjectType.Property = UserDataObjectType_Property;
class UserDataObjectType_Builder {
  constructor(value) {
    this._value = new UserDataObjectType(value);
  }
  build() {
    return new UserDataObjectType(this._value);
  }
  addAllProperties(values) {
    this._value._properties = this._value._properties.concat(values);
    return this;
  }
  addProperties(value) {
    this._value._properties = this._value._properties.concat([value]);
    return this;
  }
  setProperties(index, value) {
    this._value._properties = this._value._properties.concat();
    this._value._properties[index] = value;
    return this;
  }
  clearProperties() {
    this._value._properties = [];
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
}
UserDataObjectType.Builder = UserDataObjectType_Builder;
class UserDataObjectType_WithParent {
  /**
   * @param {UserDataObjectType} value
   * @param {UserDataObjectType_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataObjectType.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfProperties() {
    if (!this._selfProperties) {
      this._selfProperties = [];
      for (let i of this._value.properties) {
        this._selfProperties.push(new UserDataObjectType_Property.WithParent(i, null));
      }
    }
    return this._selfProperties;
  }
  get inherentProperties() {
    if (!this._inherentProperties) {
      this._inherentProperties = this._parent ? this._parent.properties : [];
    }
    return this._inherentProperties;
  }
  get properties() {
    if (!this._allProperties) {
      this._allProperties = this._parent ? this._parent.properties.concat(this.selfProperties) : this.selfProperties;
    }
    return this._allProperties;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  update(current, parent) {
    const result = new UserDataObjectType_WithParent(current, parent);
    if (this._selfProperties) {
      if (this._value.properties === current.properties) {
        result._selfProperties = this._selfProperties;
      } else {
        result._selfProperties = [];
        for (let i = 0; i < current.properties.length; i++) {
          const oldValue = this._value.properties[i];
          if (oldValue) {
            const oldCache = this._selfProperties[i];
            if (oldValue === current.properties[i]) {
              result._selfProperties[i] = oldCache;
            } else {
              result._selfProperties[i] = oldCache.update(current.properties[i], null);
            }
          } else {
            result._selfProperties[i] = new UserDataObjectType_Property.WithParent(current.properties[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserDataObjectType_WithParent.default = new UserDataObjectType_WithParent(UserDataObjectType.default, null);
UserDataObjectType.WithParent = UserDataObjectType_WithParent;
class UserDataObjectType_Descriptor {
  get properties() {
    if (!this._properties) {
      this._properties = {
        name: "properties",
        Name: "Properties",
        number: 1,
        protoType: 11,
        protoName: "properties",
        type: UserDataObjectType_Property,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._properties;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 2,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.properties,
        this.comment,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataObjectType.descriptor = new UserDataObjectType_Descriptor();
class UserDataInstance_Number {
  get descriptor() {
    return UserDataInstance_Number.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_Number) {
      return value;
    }
    return UserDataInstance_Number.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_Number();
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToDouble.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValue) {
      result.value = JsonToDouble.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._hasValue ? this._value : JsonToDouble.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_Number(this);
              copy._hasValue = true;
              copy._value = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UserDataInstance_Number(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_Number} other
   * @returns {UserDataInstance_Number}
   */
  merge(other) {
    const copy = new UserDataInstance_Number(this);
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    return copy;
  }
}
UserDataInstance_Number.default = new UserDataInstance_Number();
class UserDataInstance_Number_Builder {
  constructor(value) {
    this._value = new UserDataInstance_Number(value);
  }
  build() {
    return new UserDataInstance_Number(this._value);
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UserDataInstance_Number.Builder = UserDataInstance_Number_Builder;
class UserDataInstance_Number_WithParent {
  /**
   * @param {UserDataInstance_Number} value
   * @param {UserDataInstance_Number_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_Number.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_Number_WithParent(current, parent);
    return result;
  }
}
UserDataInstance_Number_WithParent.default = new UserDataInstance_Number_WithParent(UserDataInstance_Number.default, null);
UserDataInstance_Number.WithParent = UserDataInstance_Number_WithParent;
class UserDataInstance_Number_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 1,
        protoName: "value",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_Number.descriptor = new UserDataInstance_Number_Descriptor();
class UserDataInstance_String {
  get descriptor() {
    return UserDataInstance_String.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_String) {
      return value;
    }
    return UserDataInstance_String.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_String();
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToString.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValue) {
      result.value = JsonToString.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get value() {
    return this._hasValue ? this._value : JsonToString.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_String(this);
              copy._hasValue = true;
              copy._value = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UserDataInstance_String(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_String} other
   * @returns {UserDataInstance_String}
   */
  merge(other) {
    const copy = new UserDataInstance_String(this);
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    return copy;
  }
}
UserDataInstance_String.default = new UserDataInstance_String();
class UserDataInstance_String_Builder {
  constructor(value) {
    this._value = new UserDataInstance_String(value);
  }
  build() {
    return new UserDataInstance_String(this._value);
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UserDataInstance_String.Builder = UserDataInstance_String_Builder;
class UserDataInstance_String_WithParent {
  /**
   * @param {UserDataInstance_String} value
   * @param {UserDataInstance_String_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_String.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_String_WithParent(current, parent);
    return result;
  }
}
UserDataInstance_String_WithParent.default = new UserDataInstance_String_WithParent(UserDataInstance_String.default, null);
UserDataInstance_String.WithParent = UserDataInstance_String_WithParent;
class UserDataInstance_String_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 9,
        protoName: "value",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_String.descriptor = new UserDataInstance_String_Descriptor();
class UserDataInstance_Boolean {
  get descriptor() {
    return UserDataInstance_Boolean.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_Boolean) {
      return value;
    }
    return UserDataInstance_Boolean.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_Boolean();
    if (json.value != null) {
      result._hasValue = true;
      result._value = JsonToBoolean.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasValue) {
      result.value = JsonToBoolean.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {boolean}
   */
  get value() {
    return this._hasValue ? this._value : JsonToBoolean.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_Boolean(this);
              copy._hasValue = true;
              copy._value = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UserDataInstance_Boolean(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_Boolean} other
   * @returns {UserDataInstance_Boolean}
   */
  merge(other) {
    const copy = new UserDataInstance_Boolean(this);
    if (other._hasValue) {
      copy._hasValue = true;
      copy._value = other._value;
    }
    return copy;
  }
}
UserDataInstance_Boolean.default = new UserDataInstance_Boolean();
class UserDataInstance_Boolean_Builder {
  constructor(value) {
    this._value = new UserDataInstance_Boolean(value);
  }
  build() {
    return new UserDataInstance_Boolean(this._value);
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UserDataInstance_Boolean.Builder = UserDataInstance_Boolean_Builder;
class UserDataInstance_Boolean_WithParent {
  /**
   * @param {UserDataInstance_Boolean} value
   * @param {UserDataInstance_Boolean_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_Boolean.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (this._cachedValue === undefined) {
      if (this._value.hasValue) {
        this._cachedValue = this._value.value;
      } else {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_Boolean_WithParent(current, parent);
    return result;
  }
}
UserDataInstance_Boolean_WithParent.default = new UserDataInstance_Boolean_WithParent(UserDataInstance_Boolean.default, null);
UserDataInstance_Boolean.WithParent = UserDataInstance_Boolean_WithParent;
class UserDataInstance_Boolean_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 8,
        protoName: "value",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_Boolean.descriptor = new UserDataInstance_Boolean_Descriptor();
class UserDataInstance_ListOfNumbers_Item {
  get descriptor() {
    return UserDataInstance_ListOfNumbers_Item.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemTypeCase = 0;
    this._itemTypeValue = null;
  }
  isEmpty() {
    if (this._itemTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ListOfNumbers_Item) {
      return value;
    }
    return UserDataInstance_ListOfNumbers_Item.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ListOfNumbers_Item();
    if (json.value != null) {
      result._itemTypeCase = 1;
      result._itemTypeValue = JsonToDouble.fromJson(json.value);
    }
    if (json.referencingUserDataValue != null) {
      result._itemTypeCase = 2;
      result._itemTypeValue = JsonToString.fromJson(json.referencingUserDataValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._itemTypeCase) {
      case 1:
        result.value = JsonToDouble.toJson(this._itemTypeValue);
        break;
      case 2:
        result.referencingUserDataValue = JsonToString.toJson(this._itemTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get itemTypeCase() {
    return this._itemTypeCase;
  }
  deleteItemType(path) {
    switch (this._itemTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
      }
    }
  }
  /**
   * @returns {number}
   */
  get value() {
    return this._itemTypeCase === 1 ? this._itemTypeValue : JsonToDouble.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {string}
   */
  get referencingUserDataValue() {
    return this._itemTypeCase === 2 ? this._itemTypeValue : JsonToString.default;
  }
  setReferencingUserDataValue(path, value) {
    return {type: 'SET', path: path.concat(['referencingUserDataValue']), value};
  }
  deleteReferencingUserDataValue(path) {
    return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfNumbers_Item(this);
              copy._itemTypeCase = 1;
              copy._itemTypeValue = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 1) {
                return this;
              }
              const copy = new UserDataInstance_ListOfNumbers_Item(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "referencingUserDataValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfNumbers_Item(this);
              copy._itemTypeCase = 2;
              copy._itemTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 2) {
                return this;
              }
              const copy = new UserDataInstance_ListOfNumbers_Item(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ListOfNumbers_Item} other
   * @returns {UserDataInstance_ListOfNumbers_Item}
   */
  merge(other) {
    const copy = new UserDataInstance_ListOfNumbers_Item(this);
    if (other._itemTypeCase === 1) {
      copy._itemTypeCase = 1;
      copy._itemTypeValue = other._itemTypeValue;
    }
    if (other._itemTypeCase === 1) {
      copy._itemTypeCase = 1;
      copy._itemTypeValue = other._itemTypeValue;
    }
    return copy;
  }
}
UserDataInstance_ListOfNumbers_Item.default = new UserDataInstance_ListOfNumbers_Item();
class UserDataInstance_ListOfNumbers_Item_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ListOfNumbers_Item(value);
  }
  build() {
    return new UserDataInstance_ListOfNumbers_Item(this._value);
  }
  clearitemType() {
    this._value._itemTypeCase = 0;
    this._value._itemTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._itemTypeCase = 1;
    this._value._itemTypeValue = value;
    return this;
  }
  setReferencingUserDataValue(value) {
    this._value._itemTypeCase = 2;
    this._value._itemTypeValue = value;
    return this;
  }
}
UserDataInstance_ListOfNumbers_Item.Builder = UserDataInstance_ListOfNumbers_Item_Builder;
class UserDataInstance_ListOfNumbers_Item_WithParent {
  /**
   * @param {UserDataInstance_ListOfNumbers_Item} value
   * @param {UserDataInstance_ListOfNumbers_Item_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ListOfNumbers_Item.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get itemTypeCase() {
    if (this._cacheditemTypeCase === undefined) {
      if (this._value._itemTypeCase === 0) {
        this._cacheditemTypeCase = this._parent ? this._parent.itemTypeCase : 0;
      } else {
        this._cacheditemTypeCase = this._value._itemTypeCase;
      }
    }
    return this._cacheditemTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      } else {
        this._cachedValue = this._value.value;
      }
    }
    return this._cachedValue;
  }
  get referencingUserDataValue() {
    if (!this._cachedReferencingUserDataValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedReferencingUserDataValue = this._parent ? this._parent.referencingUserDataValue : this._value.referencingUserDataValue;
      } else {
        this._cachedReferencingUserDataValue = this._value.referencingUserDataValue;
      }
    }
    return this._cachedReferencingUserDataValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_ListOfNumbers_Item_WithParent(current, parent);
    return result;
  }
}
UserDataInstance_ListOfNumbers_Item_WithParent.default = new UserDataInstance_ListOfNumbers_Item_WithParent(UserDataInstance_ListOfNumbers_Item.default, null);
UserDataInstance_ListOfNumbers_Item.WithParent = UserDataInstance_ListOfNumbers_Item_WithParent;
class UserDataInstance_ListOfNumbers_Item_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 1,
        protoName: "value",
        oneofIndex: 0,
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get referencingUserDataValue() {
    if (!this._referencingUserDataValue) {
      this._referencingUserDataValue = {
        name: "referencingUserDataValue",
        Name: "ReferencingUserDataValue",
        number: 2,
        protoType: 9,
        protoName: "referencing_user_data_value",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._referencingUserDataValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.referencingUserDataValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "itemType",
        Name: "ItemType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_ListOfNumbers_Item.descriptor = new UserDataInstance_ListOfNumbers_Item_Descriptor();
class UserDataInstance_ListOfNumbers {
  get descriptor() {
    return UserDataInstance_ListOfNumbers.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._items = [];
  }
  isEmpty() {
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ListOfNumbers) {
      return value;
    }
    return UserDataInstance_ListOfNumbers.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ListOfNumbers();
    result._items = JsonToList(json.items, UserDataInstance_ListOfNumbers_Item);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, UserDataInstance_ListOfNumbers_Item);
    }
    return result;
  }
  /**
   * @returns {UserDataInstance_ListOfNumbers_Item[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, UserDataInstance_ListOfNumbers_Item)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfNumbers(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(UserDataInstance_ListOfNumbers_Item.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UserDataInstance_ListOfNumbers(this);
              copy._items = copy._items.concat([UserDataInstance_ListOfNumbers_Item.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new UserDataInstance_ListOfNumbers(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfNumbers(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = UserDataInstance_ListOfNumbers_Item.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UserDataInstance_ListOfNumbers(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserDataInstance_ListOfNumbers(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ListOfNumbers} other
   * @returns {UserDataInstance_ListOfNumbers}
   */
  merge(other) {
    const copy = new UserDataInstance_ListOfNumbers(this);
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
UserDataInstance_ListOfNumbers.default = new UserDataInstance_ListOfNumbers();
UserDataInstance_ListOfNumbers.Item = UserDataInstance_ListOfNumbers_Item;
class UserDataInstance_ListOfNumbers_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ListOfNumbers(value);
  }
  build() {
    return new UserDataInstance_ListOfNumbers(this._value);
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
UserDataInstance_ListOfNumbers.Builder = UserDataInstance_ListOfNumbers_Builder;
class UserDataInstance_ListOfNumbers_WithParent {
  /**
   * @param {UserDataInstance_ListOfNumbers} value
   * @param {UserDataInstance_ListOfNumbers_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ListOfNumbers.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new UserDataInstance_ListOfNumbers_Item.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new UserDataInstance_ListOfNumbers_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new UserDataInstance_ListOfNumbers_Item.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserDataInstance_ListOfNumbers_WithParent.default = new UserDataInstance_ListOfNumbers_WithParent(UserDataInstance_ListOfNumbers.default, null);
UserDataInstance_ListOfNumbers.WithParent = UserDataInstance_ListOfNumbers_WithParent;
class UserDataInstance_ListOfNumbers_Descriptor {
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 1,
        protoType: 11,
        protoName: "items",
        type: UserDataInstance_ListOfNumbers_Item,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UserDataInstance_ListOfNumbers.descriptor = new UserDataInstance_ListOfNumbers_Descriptor();
class UserDataInstance_ListOfStrings_Item {
  get descriptor() {
    return UserDataInstance_ListOfStrings_Item.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemTypeCase = 0;
    this._itemTypeValue = null;
  }
  isEmpty() {
    if (this._itemTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ListOfStrings_Item) {
      return value;
    }
    return UserDataInstance_ListOfStrings_Item.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ListOfStrings_Item();
    if (json.value != null) {
      result._itemTypeCase = 1;
      result._itemTypeValue = JsonToString.fromJson(json.value);
    }
    if (json.referencingUserDataValue != null) {
      result._itemTypeCase = 2;
      result._itemTypeValue = JsonToString.fromJson(json.referencingUserDataValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._itemTypeCase) {
      case 1:
        result.value = JsonToString.toJson(this._itemTypeValue);
        break;
      case 2:
        result.referencingUserDataValue = JsonToString.toJson(this._itemTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get itemTypeCase() {
    return this._itemTypeCase;
  }
  deleteItemType(path) {
    switch (this._itemTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
      }
    }
  }
  /**
   * @returns {string}
   */
  get value() {
    return this._itemTypeCase === 1 ? this._itemTypeValue : JsonToString.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {string}
   */
  get referencingUserDataValue() {
    return this._itemTypeCase === 2 ? this._itemTypeValue : JsonToString.default;
  }
  setReferencingUserDataValue(path, value) {
    return {type: 'SET', path: path.concat(['referencingUserDataValue']), value};
  }
  deleteReferencingUserDataValue(path) {
    return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfStrings_Item(this);
              copy._itemTypeCase = 1;
              copy._itemTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 1) {
                return this;
              }
              const copy = new UserDataInstance_ListOfStrings_Item(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "referencingUserDataValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfStrings_Item(this);
              copy._itemTypeCase = 2;
              copy._itemTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 2) {
                return this;
              }
              const copy = new UserDataInstance_ListOfStrings_Item(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ListOfStrings_Item} other
   * @returns {UserDataInstance_ListOfStrings_Item}
   */
  merge(other) {
    const copy = new UserDataInstance_ListOfStrings_Item(this);
    if (other._itemTypeCase === 1) {
      copy._itemTypeCase = 1;
      copy._itemTypeValue = other._itemTypeValue;
    }
    if (other._itemTypeCase === 1) {
      copy._itemTypeCase = 1;
      copy._itemTypeValue = other._itemTypeValue;
    }
    return copy;
  }
}
UserDataInstance_ListOfStrings_Item.default = new UserDataInstance_ListOfStrings_Item();
class UserDataInstance_ListOfStrings_Item_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ListOfStrings_Item(value);
  }
  build() {
    return new UserDataInstance_ListOfStrings_Item(this._value);
  }
  clearitemType() {
    this._value._itemTypeCase = 0;
    this._value._itemTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._itemTypeCase = 1;
    this._value._itemTypeValue = value;
    return this;
  }
  setReferencingUserDataValue(value) {
    this._value._itemTypeCase = 2;
    this._value._itemTypeValue = value;
    return this;
  }
}
UserDataInstance_ListOfStrings_Item.Builder = UserDataInstance_ListOfStrings_Item_Builder;
class UserDataInstance_ListOfStrings_Item_WithParent {
  /**
   * @param {UserDataInstance_ListOfStrings_Item} value
   * @param {UserDataInstance_ListOfStrings_Item_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ListOfStrings_Item.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get itemTypeCase() {
    if (this._cacheditemTypeCase === undefined) {
      if (this._value._itemTypeCase === 0) {
        this._cacheditemTypeCase = this._parent ? this._parent.itemTypeCase : 0;
      } else {
        this._cacheditemTypeCase = this._value._itemTypeCase;
      }
    }
    return this._cacheditemTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      } else {
        this._cachedValue = this._value.value;
      }
    }
    return this._cachedValue;
  }
  get referencingUserDataValue() {
    if (!this._cachedReferencingUserDataValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedReferencingUserDataValue = this._parent ? this._parent.referencingUserDataValue : this._value.referencingUserDataValue;
      } else {
        this._cachedReferencingUserDataValue = this._value.referencingUserDataValue;
      }
    }
    return this._cachedReferencingUserDataValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_ListOfStrings_Item_WithParent(current, parent);
    return result;
  }
}
UserDataInstance_ListOfStrings_Item_WithParent.default = new UserDataInstance_ListOfStrings_Item_WithParent(UserDataInstance_ListOfStrings_Item.default, null);
UserDataInstance_ListOfStrings_Item.WithParent = UserDataInstance_ListOfStrings_Item_WithParent;
class UserDataInstance_ListOfStrings_Item_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 9,
        protoName: "value",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get referencingUserDataValue() {
    if (!this._referencingUserDataValue) {
      this._referencingUserDataValue = {
        name: "referencingUserDataValue",
        Name: "ReferencingUserDataValue",
        number: 2,
        protoType: 9,
        protoName: "referencing_user_data_value",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._referencingUserDataValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.referencingUserDataValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "itemType",
        Name: "ItemType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_ListOfStrings_Item.descriptor = new UserDataInstance_ListOfStrings_Item_Descriptor();
class UserDataInstance_ListOfStrings {
  get descriptor() {
    return UserDataInstance_ListOfStrings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._items = [];
  }
  isEmpty() {
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ListOfStrings) {
      return value;
    }
    return UserDataInstance_ListOfStrings.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ListOfStrings();
    result._items = JsonToList(json.items, UserDataInstance_ListOfStrings_Item);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, UserDataInstance_ListOfStrings_Item);
    }
    return result;
  }
  /**
   * @returns {UserDataInstance_ListOfStrings_Item[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, UserDataInstance_ListOfStrings_Item)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfStrings(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(UserDataInstance_ListOfStrings_Item.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UserDataInstance_ListOfStrings(this);
              copy._items = copy._items.concat([UserDataInstance_ListOfStrings_Item.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new UserDataInstance_ListOfStrings(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfStrings(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = UserDataInstance_ListOfStrings_Item.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UserDataInstance_ListOfStrings(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserDataInstance_ListOfStrings(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ListOfStrings} other
   * @returns {UserDataInstance_ListOfStrings}
   */
  merge(other) {
    const copy = new UserDataInstance_ListOfStrings(this);
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
UserDataInstance_ListOfStrings.default = new UserDataInstance_ListOfStrings();
UserDataInstance_ListOfStrings.Item = UserDataInstance_ListOfStrings_Item;
class UserDataInstance_ListOfStrings_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ListOfStrings(value);
  }
  build() {
    return new UserDataInstance_ListOfStrings(this._value);
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
UserDataInstance_ListOfStrings.Builder = UserDataInstance_ListOfStrings_Builder;
class UserDataInstance_ListOfStrings_WithParent {
  /**
   * @param {UserDataInstance_ListOfStrings} value
   * @param {UserDataInstance_ListOfStrings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ListOfStrings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new UserDataInstance_ListOfStrings_Item.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new UserDataInstance_ListOfStrings_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new UserDataInstance_ListOfStrings_Item.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserDataInstance_ListOfStrings_WithParent.default = new UserDataInstance_ListOfStrings_WithParent(UserDataInstance_ListOfStrings.default, null);
UserDataInstance_ListOfStrings.WithParent = UserDataInstance_ListOfStrings_WithParent;
class UserDataInstance_ListOfStrings_Descriptor {
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 1,
        protoType: 11,
        protoName: "items",
        type: UserDataInstance_ListOfStrings_Item,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UserDataInstance_ListOfStrings.descriptor = new UserDataInstance_ListOfStrings_Descriptor();
class UserDataInstance_ListOfBooleans_Item {
  get descriptor() {
    return UserDataInstance_ListOfBooleans_Item.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemTypeCase = 0;
    this._itemTypeValue = null;
  }
  isEmpty() {
    if (this._itemTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ListOfBooleans_Item) {
      return value;
    }
    return UserDataInstance_ListOfBooleans_Item.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ListOfBooleans_Item();
    if (json.value != null) {
      result._itemTypeCase = 1;
      result._itemTypeValue = JsonToBoolean.fromJson(json.value);
    }
    if (json.referencingUserDataValue != null) {
      result._itemTypeCase = 2;
      result._itemTypeValue = JsonToString.fromJson(json.referencingUserDataValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._itemTypeCase) {
      case 1:
        result.value = JsonToBoolean.toJson(this._itemTypeValue);
        break;
      case 2:
        result.referencingUserDataValue = JsonToString.toJson(this._itemTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get itemTypeCase() {
    return this._itemTypeCase;
  }
  deleteItemType(path) {
    switch (this._itemTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
      }
    }
  }
  /**
   * @returns {boolean}
   */
  get value() {
    return this._itemTypeCase === 1 ? this._itemTypeValue : JsonToBoolean.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {string}
   */
  get referencingUserDataValue() {
    return this._itemTypeCase === 2 ? this._itemTypeValue : JsonToString.default;
  }
  setReferencingUserDataValue(path, value) {
    return {type: 'SET', path: path.concat(['referencingUserDataValue']), value};
  }
  deleteReferencingUserDataValue(path) {
    return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfBooleans_Item(this);
              copy._itemTypeCase = 1;
              copy._itemTypeValue = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 1) {
                return this;
              }
              const copy = new UserDataInstance_ListOfBooleans_Item(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "referencingUserDataValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfBooleans_Item(this);
              copy._itemTypeCase = 2;
              copy._itemTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 2) {
                return this;
              }
              const copy = new UserDataInstance_ListOfBooleans_Item(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ListOfBooleans_Item} other
   * @returns {UserDataInstance_ListOfBooleans_Item}
   */
  merge(other) {
    const copy = new UserDataInstance_ListOfBooleans_Item(this);
    if (other._itemTypeCase === 1) {
      copy._itemTypeCase = 1;
      copy._itemTypeValue = other._itemTypeValue;
    }
    if (other._itemTypeCase === 1) {
      copy._itemTypeCase = 1;
      copy._itemTypeValue = other._itemTypeValue;
    }
    return copy;
  }
}
UserDataInstance_ListOfBooleans_Item.default = new UserDataInstance_ListOfBooleans_Item();
class UserDataInstance_ListOfBooleans_Item_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ListOfBooleans_Item(value);
  }
  build() {
    return new UserDataInstance_ListOfBooleans_Item(this._value);
  }
  clearitemType() {
    this._value._itemTypeCase = 0;
    this._value._itemTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._itemTypeCase = 1;
    this._value._itemTypeValue = value;
    return this;
  }
  setReferencingUserDataValue(value) {
    this._value._itemTypeCase = 2;
    this._value._itemTypeValue = value;
    return this;
  }
}
UserDataInstance_ListOfBooleans_Item.Builder = UserDataInstance_ListOfBooleans_Item_Builder;
class UserDataInstance_ListOfBooleans_Item_WithParent {
  /**
   * @param {UserDataInstance_ListOfBooleans_Item} value
   * @param {UserDataInstance_ListOfBooleans_Item_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ListOfBooleans_Item.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get itemTypeCase() {
    if (this._cacheditemTypeCase === undefined) {
      if (this._value._itemTypeCase === 0) {
        this._cacheditemTypeCase = this._parent ? this._parent.itemTypeCase : 0;
      } else {
        this._cacheditemTypeCase = this._value._itemTypeCase;
      }
    }
    return this._cacheditemTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedValue = this._parent ? this._parent.value : this._value.value;
      } else {
        this._cachedValue = this._value.value;
      }
    }
    return this._cachedValue;
  }
  get referencingUserDataValue() {
    if (!this._cachedReferencingUserDataValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedReferencingUserDataValue = this._parent ? this._parent.referencingUserDataValue : this._value.referencingUserDataValue;
      } else {
        this._cachedReferencingUserDataValue = this._value.referencingUserDataValue;
      }
    }
    return this._cachedReferencingUserDataValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_ListOfBooleans_Item_WithParent(current, parent);
    return result;
  }
}
UserDataInstance_ListOfBooleans_Item_WithParent.default = new UserDataInstance_ListOfBooleans_Item_WithParent(UserDataInstance_ListOfBooleans_Item.default, null);
UserDataInstance_ListOfBooleans_Item.WithParent = UserDataInstance_ListOfBooleans_Item_WithParent;
class UserDataInstance_ListOfBooleans_Item_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 8,
        protoName: "value",
        oneofIndex: 0,
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get referencingUserDataValue() {
    if (!this._referencingUserDataValue) {
      this._referencingUserDataValue = {
        name: "referencingUserDataValue",
        Name: "ReferencingUserDataValue",
        number: 2,
        protoType: 9,
        protoName: "referencing_user_data_value",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._referencingUserDataValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.referencingUserDataValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "itemType",
        Name: "ItemType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_ListOfBooleans_Item.descriptor = new UserDataInstance_ListOfBooleans_Item_Descriptor();
class UserDataInstance_ListOfBooleans {
  get descriptor() {
    return UserDataInstance_ListOfBooleans.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._items = [];
  }
  isEmpty() {
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ListOfBooleans) {
      return value;
    }
    return UserDataInstance_ListOfBooleans.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ListOfBooleans();
    result._items = JsonToList(json.items, UserDataInstance_ListOfBooleans_Item);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, UserDataInstance_ListOfBooleans_Item);
    }
    return result;
  }
  /**
   * @returns {UserDataInstance_ListOfBooleans_Item[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, UserDataInstance_ListOfBooleans_Item)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfBooleans(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(UserDataInstance_ListOfBooleans_Item.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UserDataInstance_ListOfBooleans(this);
              copy._items = copy._items.concat([UserDataInstance_ListOfBooleans_Item.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new UserDataInstance_ListOfBooleans(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfBooleans(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = UserDataInstance_ListOfBooleans_Item.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UserDataInstance_ListOfBooleans(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserDataInstance_ListOfBooleans(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ListOfBooleans} other
   * @returns {UserDataInstance_ListOfBooleans}
   */
  merge(other) {
    const copy = new UserDataInstance_ListOfBooleans(this);
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
UserDataInstance_ListOfBooleans.default = new UserDataInstance_ListOfBooleans();
UserDataInstance_ListOfBooleans.Item = UserDataInstance_ListOfBooleans_Item;
class UserDataInstance_ListOfBooleans_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ListOfBooleans(value);
  }
  build() {
    return new UserDataInstance_ListOfBooleans(this._value);
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
UserDataInstance_ListOfBooleans.Builder = UserDataInstance_ListOfBooleans_Builder;
class UserDataInstance_ListOfBooleans_WithParent {
  /**
   * @param {UserDataInstance_ListOfBooleans} value
   * @param {UserDataInstance_ListOfBooleans_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ListOfBooleans.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new UserDataInstance_ListOfBooleans_Item.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new UserDataInstance_ListOfBooleans_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new UserDataInstance_ListOfBooleans_Item.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserDataInstance_ListOfBooleans_WithParent.default = new UserDataInstance_ListOfBooleans_WithParent(UserDataInstance_ListOfBooleans.default, null);
UserDataInstance_ListOfBooleans.WithParent = UserDataInstance_ListOfBooleans_WithParent;
class UserDataInstance_ListOfBooleans_Descriptor {
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 1,
        protoType: 11,
        protoName: "items",
        type: UserDataInstance_ListOfBooleans_Item,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UserDataInstance_ListOfBooleans.descriptor = new UserDataInstance_ListOfBooleans_Descriptor();
class UserDataInstance_ObjectProperty {
  get descriptor() {
    return UserDataInstance_ObjectProperty.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ObjectProperty) {
      return value;
    }
    return UserDataInstance_ObjectProperty.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ObjectProperty();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UserDataInstance.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UserDataInstance.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {UserDataInstance}
   */
  get value() {
    return this._hasValue ? this._value : UserDataInstance.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ObjectProperty(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new UserDataInstance_ObjectProperty(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ObjectProperty(this);
              copy._hasValue = true;
              copy._value = UserDataInstance.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UserDataInstance_ObjectProperty(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UserDataInstance_ObjectProperty(this);
            copy._hasValue = true;
            copy._value = UserDataInstance.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UserDataInstance_ObjectProperty(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ObjectProperty} other
   * @returns {UserDataInstance_ObjectProperty}
   */
  merge(other) {
    const copy = new UserDataInstance_ObjectProperty(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UserDataInstance_ObjectProperty.default = new UserDataInstance_ObjectProperty();
class UserDataInstance_ObjectProperty_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ObjectProperty(value);
  }
  build() {
    return new UserDataInstance_ObjectProperty(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UserDataInstance_ObjectProperty.Builder = UserDataInstance_ObjectProperty_Builder;
class UserDataInstance_ObjectProperty_WithParent {
  /**
   * @param {UserDataInstance_ObjectProperty} value
   * @param {UserDataInstance_ObjectProperty_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ObjectProperty.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UserDataInstance.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UserDataInstance.WithParent(UserDataInstance.default, this._parent.value) : UserDataInstance.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_ObjectProperty_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UserDataInstance_ObjectProperty_WithParent.default = new UserDataInstance_ObjectProperty_WithParent(UserDataInstance_ObjectProperty.default, null);
UserDataInstance_ObjectProperty.WithParent = UserDataInstance_ObjectProperty_WithParent;
class UserDataInstance_ObjectProperty_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UserDataInstance,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_ObjectProperty.descriptor = new UserDataInstance_ObjectProperty_Descriptor();
class UserDataInstance_ObjectData {
  get descriptor() {
    return UserDataInstance_ObjectData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._properties = [];
  }
  isEmpty() {
    if (this._properties.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ObjectData) {
      return value;
    }
    return UserDataInstance_ObjectData.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ObjectData();
    result._properties = JsonToList(json.properties, UserDataInstance_ObjectProperty);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._properties.length > 0) {
      result.properties = ArrayToJson(this._properties, UserDataInstance_ObjectProperty);
    }
    return result;
  }
  /**
   * @returns {UserDataInstance_ObjectProperty[]}
   */
  get properties() {
    return this._properties;
  }
  addProperties(path, value) {
    return {type: 'ADD', path: path.concat(['properties']), value: value.toJson()};
  }
  setProperties(path, value) {
    return {type: 'SET', path: path.concat(['properties']), value: ArrayToJson(value, UserDataInstance_ObjectProperty)};
  }
  setPropertiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['properties', key]), value: value.toJson()};
  }
  deleteProperties(path) {
    return {type: 'DELETE', path: path.concat(['properties'])};
  }
  deletePropertiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['properties', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "properties": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ObjectData(this);
              copy._properties = [];        for (let i of value) {
                copy._properties.push(UserDataInstance_ObjectProperty.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UserDataInstance_ObjectData(this);
              copy._properties = copy._properties.concat([UserDataInstance_ObjectProperty.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._properties.length === 0) {
                return this;
              }
              const copy = new UserDataInstance_ObjectData(this);
              copy._properties = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._properties.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ObjectData(this);
              copy._properties = copy._properties.slice();
              copy._properties[path[1]] = UserDataInstance_ObjectProperty.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UserDataInstance_ObjectData(this);
              copy._properties = copy._properties.slice(0, path[1]).concat(copy._properties.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._properties.length) {
            return this;
          }
          const oldValue = this._properties[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserDataInstance_ObjectData(this);
          copy._properties = copy._properties.slice();
          copy._properties[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ObjectData} other
   * @returns {UserDataInstance_ObjectData}
   */
  merge(other) {
    const copy = new UserDataInstance_ObjectData(this);
    copy._properties = this._properties.concat(other._properties);
    return copy;
  }
}
UserDataInstance_ObjectData.default = new UserDataInstance_ObjectData();
class UserDataInstance_ObjectData_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ObjectData(value);
  }
  build() {
    return new UserDataInstance_ObjectData(this._value);
  }
  addAllProperties(values) {
    this._value._properties = this._value._properties.concat(values);
    return this;
  }
  addProperties(value) {
    this._value._properties = this._value._properties.concat([value]);
    return this;
  }
  setProperties(index, value) {
    this._value._properties = this._value._properties.concat();
    this._value._properties[index] = value;
    return this;
  }
  clearProperties() {
    this._value._properties = [];
    return this;
  }
}
UserDataInstance_ObjectData.Builder = UserDataInstance_ObjectData_Builder;
class UserDataInstance_ObjectData_WithParent {
  /**
   * @param {UserDataInstance_ObjectData} value
   * @param {UserDataInstance_ObjectData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ObjectData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfProperties() {
    if (!this._selfProperties) {
      this._selfProperties = [];
      for (let i of this._value.properties) {
        this._selfProperties.push(new UserDataInstance_ObjectProperty.WithParent(i, null));
      }
    }
    return this._selfProperties;
  }
  get inherentProperties() {
    if (!this._inherentProperties) {
      this._inherentProperties = this._parent ? this._parent.properties : [];
    }
    return this._inherentProperties;
  }
  get properties() {
    if (!this._allProperties) {
      this._allProperties = this._parent ? this._parent.properties.concat(this.selfProperties) : this.selfProperties;
    }
    return this._allProperties;
  }
  update(current, parent) {
    const result = new UserDataInstance_ObjectData_WithParent(current, parent);
    if (this._selfProperties) {
      if (this._value.properties === current.properties) {
        result._selfProperties = this._selfProperties;
      } else {
        result._selfProperties = [];
        for (let i = 0; i < current.properties.length; i++) {
          const oldValue = this._value.properties[i];
          if (oldValue) {
            const oldCache = this._selfProperties[i];
            if (oldValue === current.properties[i]) {
              result._selfProperties[i] = oldCache;
            } else {
              result._selfProperties[i] = oldCache.update(current.properties[i], null);
            }
          } else {
            result._selfProperties[i] = new UserDataInstance_ObjectProperty.WithParent(current.properties[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserDataInstance_ObjectData_WithParent.default = new UserDataInstance_ObjectData_WithParent(UserDataInstance_ObjectData.default, null);
UserDataInstance_ObjectData.WithParent = UserDataInstance_ObjectData_WithParent;
class UserDataInstance_ObjectData_Descriptor {
  get properties() {
    if (!this._properties) {
      this._properties = {
        name: "properties",
        Name: "Properties",
        number: 1,
        protoType: 11,
        protoName: "properties",
        type: UserDataInstance_ObjectProperty,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._properties;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.properties,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UserDataInstance_ObjectData.descriptor = new UserDataInstance_ObjectData_Descriptor();
class UserDataInstance_Object {
  get descriptor() {
    return UserDataInstance_Object.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUserDataType = false;
    this._userDataType = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasUserDataType) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_Object) {
      return value;
    }
    return UserDataInstance_Object.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_Object();
    if (json.userDataType != null) {
      result._hasUserDataType = true;
      result._userDataType = JsonToString.fromJson(json.userDataType);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UserDataInstance_ObjectData.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUserDataType) {
      result.userDataType = JsonToString.toJson(this._userDataType);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UserDataInstance_ObjectData.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get userDataType() {
    return this._hasUserDataType ? this._userDataType : JsonToString.default;
  }
  get hasUserDataType() {
    return this._hasUserDataType;
  }
  setUserDataType(path, value) {
    return {type: 'SET', path: path.concat(['userDataType']), value};
  }
  deleteUserDataType(path) {
    return {type: 'DELETE', path: path.concat(['userDataType'])};
  }
  /**
   * @returns {UserDataInstance_ObjectData}
   */
  get value() {
    return this._hasValue ? this._value : UserDataInstance_ObjectData.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "userDataType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_Object(this);
              copy._hasUserDataType = true;
              copy._userDataType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUserDataType) {
                return this;
              }
              const copy = new UserDataInstance_Object(this);
              copy._hasUserDataType = false;
              copy._userDataType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_Object(this);
              copy._hasValue = true;
              copy._value = UserDataInstance_ObjectData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UserDataInstance_Object(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UserDataInstance_Object(this);
            copy._hasValue = true;
            copy._value = UserDataInstance_ObjectData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UserDataInstance_Object(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_Object} other
   * @returns {UserDataInstance_Object}
   */
  merge(other) {
    const copy = new UserDataInstance_Object(this);
    if (other._hasUserDataType) {
      copy._hasUserDataType = true;
      copy._userDataType = other._userDataType;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UserDataInstance_Object.default = new UserDataInstance_Object();
class UserDataInstance_Object_Builder {
  constructor(value) {
    this._value = new UserDataInstance_Object(value);
  }
  build() {
    return new UserDataInstance_Object(this._value);
  }
  setUserDataType(value) {
    this._value._hasUserDataType = true;
    this._value._userDataType = value;
    return this;
  }
  deleteUserDataType() {
    this._value._hasUserDataType = false;
    this._value._userDataType = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UserDataInstance_Object.Builder = UserDataInstance_Object_Builder;
class UserDataInstance_Object_WithParent {
  /**
   * @param {UserDataInstance_Object} value
   * @param {UserDataInstance_Object_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_Object.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUserDataType() {
    if (this._cachedHasUserDataType === undefined) {
      if (this._value.hasUserDataType) {
        this._cachedHasUserDataType = true;
      } else {
        this._cachedHasUserDataType = this._parent ? this._parent.hasUserDataType : false;
      }
    }
    return this._cachedHasUserDataType;
  }
  get userDataType() {
    if (this._cachedUserDataType === undefined) {
      if (this._value.hasUserDataType) {
        this._cachedUserDataType = this._value.userDataType;
      } else {
        this._cachedUserDataType = this._parent ? this._parent.userDataType : this._value.userDataType;
      }
    }
    return this._cachedUserDataType;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UserDataInstance_ObjectData.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UserDataInstance_ObjectData.WithParent(UserDataInstance_ObjectData.default, this._parent.value) : UserDataInstance_ObjectData.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_Object_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UserDataInstance_Object_WithParent.default = new UserDataInstance_Object_WithParent(UserDataInstance_Object.default, null);
UserDataInstance_Object.WithParent = UserDataInstance_Object_WithParent;
class UserDataInstance_Object_Descriptor {
  get userDataType() {
    if (!this._userDataType) {
      this._userDataType = {
        name: "userDataType",
        Name: "UserDataType",
        number: 1,
        protoType: 9,
        protoName: "user_data_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._userDataType;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UserDataInstance_ObjectData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.userDataType,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUserDataType",
        Name: "DummyOneofForUserDataType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForValue",
        Name: "DummyOneofForValue",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_Object.descriptor = new UserDataInstance_Object_Descriptor();
class UserDataInstance_ObjectListItem {
  get descriptor() {
    return UserDataInstance_ObjectListItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._itemTypeCase = 0;
    this._itemTypeValue = null;
  }
  isEmpty() {
    if (this._itemTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ObjectListItem) {
      return value;
    }
    return UserDataInstance_ObjectListItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ObjectListItem();
    if (json.value != null) {
      result._itemTypeCase = 1;
      result._itemTypeValue = UserDataInstance_Object.fromJson(json.value);
    }
    if (json.referencingUserDataValue != null) {
      result._itemTypeCase = 2;
      result._itemTypeValue = JsonToString.fromJson(json.referencingUserDataValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._itemTypeCase) {
      case 1:
        result.value = UserDataInstance_Object.toJson(this._itemTypeValue);
        break;
      case 2:
        result.referencingUserDataValue = JsonToString.toJson(this._itemTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get itemTypeCase() {
    return this._itemTypeCase;
  }
  deleteItemType(path) {
    switch (this._itemTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['value'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
      }
    }
  }
  /**
   * @returns {UserDataInstance_Object}
   */
  get value() {
    return this._itemTypeCase === 1 ? this._itemTypeValue : UserDataInstance_Object.default;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  /**
   * @returns {string}
   */
  get referencingUserDataValue() {
    return this._itemTypeCase === 2 ? this._itemTypeValue : JsonToString.default;
  }
  setReferencingUserDataValue(path, value) {
    return {type: 'SET', path: path.concat(['referencingUserDataValue']), value};
  }
  deleteReferencingUserDataValue(path) {
    return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ObjectListItem(this);
              copy._itemTypeCase = 1;
              copy._itemTypeValue = UserDataInstance_Object.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 1) {
                return this;
              }
              const copy = new UserDataInstance_ObjectListItem(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._itemTypeCase !== 1) {
            const copy = new UserDataInstance_ObjectListItem(this);
            copy._itemTypeCase = 1;
            copy._itemTypeValue = UserDataInstance_Object.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.value.apply(type, path.slice(1), value);
          if (newValue === this.value) {
            return this;
          }
          const copy = new UserDataInstance_ObjectListItem(this);
          copy._itemTypeCase = 1;
          copy._itemTypeValue = newValue;
          return copy;
        }
      }
      case "referencingUserDataValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ObjectListItem(this);
              copy._itemTypeCase = 2;
              copy._itemTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._itemTypeCase !== 2) {
                return this;
              }
              const copy = new UserDataInstance_ObjectListItem(this);
              copy._itemTypeCase = 0;
              copy._itemTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ObjectListItem} other
   * @returns {UserDataInstance_ObjectListItem}
   */
  merge(other) {
    const copy = new UserDataInstance_ObjectListItem(this);
    if (other._itemTypeCase === 1) {
      if (this._itemTypeCase === 1) {
        copy._itemTypeValue = copy._itemTypeValue.merge(other._itemTypeValue);
      } else {
        copy._itemTypeValue = other._itemTypeValue;
      }
      copy._itemTypeCase = 1;
    }
    if (other._itemTypeCase === 1) {
      copy._itemTypeCase = 1;
      copy._itemTypeValue = other._itemTypeValue;
    }
    return copy;
  }
}
UserDataInstance_ObjectListItem.default = new UserDataInstance_ObjectListItem();
class UserDataInstance_ObjectListItem_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ObjectListItem(value);
  }
  build() {
    return new UserDataInstance_ObjectListItem(this._value);
  }
  clearitemType() {
    this._value._itemTypeCase = 0;
    this._value._itemTypeValue = null;
    return this;
  }
  setValue(value) {
    this._value._itemTypeCase = 1;
    this._value._itemTypeValue = value;
    return this;
  }
  setReferencingUserDataValue(value) {
    this._value._itemTypeCase = 2;
    this._value._itemTypeValue = value;
    return this;
  }
}
UserDataInstance_ObjectListItem.Builder = UserDataInstance_ObjectListItem_Builder;
class UserDataInstance_ObjectListItem_WithParent {
  /**
   * @param {UserDataInstance_ObjectListItem} value
   * @param {UserDataInstance_ObjectListItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ObjectListItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get itemTypeCase() {
    if (this._cacheditemTypeCase === undefined) {
      if (this._value._itemTypeCase === 0) {
        this._cacheditemTypeCase = this._parent ? this._parent.itemTypeCase : 0;
      } else {
        this._cacheditemTypeCase = this._value._itemTypeCase;
      }
    }
    return this._cacheditemTypeCase;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedValue = this._parent ? new UserDataInstance_Object.WithParent(UserDataInstance_Object.default, this._parent.value) : this._value.value;
      } else if (this._value._itemTypeCase === 1) {
        this._cachedValue = new UserDataInstance_Object.WithParent(this._value.value, this._parent && this._parent.itemTypeCase === 1 ? this._parent.value : null);
      } else {
        this._cachedValue = UserDataInstance_Object.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  get referencingUserDataValue() {
    if (!this._cachedReferencingUserDataValue) {
      if (this._value._itemTypeCase === 0) {
        this._cachedReferencingUserDataValue = this._parent ? this._parent.referencingUserDataValue : this._value.referencingUserDataValue;
      } else {
        this._cachedReferencingUserDataValue = this._value.referencingUserDataValue;
      }
    }
    return this._cachedReferencingUserDataValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_ObjectListItem_WithParent(current, parent);
    if (this._cachedValue && this._value._itemTypeCase === 1 && current._itemTypeCase === 1) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.itemTypeCase === 1 ? parent.value : null);
      }
    }
    return result;
  }
}
UserDataInstance_ObjectListItem_WithParent.default = new UserDataInstance_ObjectListItem_WithParent(UserDataInstance_ObjectListItem.default, null);
UserDataInstance_ObjectListItem.WithParent = UserDataInstance_ObjectListItem_WithParent;
class UserDataInstance_ObjectListItem_Descriptor {
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 1,
        protoType: 11,
        protoName: "value",
        oneofIndex: 0,
        type: UserDataInstance_Object,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get referencingUserDataValue() {
    if (!this._referencingUserDataValue) {
      this._referencingUserDataValue = {
        name: "referencingUserDataValue",
        Name: "ReferencingUserDataValue",
        number: 2,
        protoType: 9,
        protoName: "referencing_user_data_value",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._referencingUserDataValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.value,
        this.referencingUserDataValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "itemType",
        Name: "ItemType",
        fields: [
          this.fields[0],
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_ObjectListItem.descriptor = new UserDataInstance_ObjectListItem_Descriptor();
class UserDataInstance_ListOfObjects {
  get descriptor() {
    return UserDataInstance_ListOfObjects.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUserDataType = false;
    this._userDataType = null;
    this._items = [];
  }
  isEmpty() {
    if (this._hasUserDataType) return false;
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance_ListOfObjects) {
      return value;
    }
    return UserDataInstance_ListOfObjects.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance_ListOfObjects();
    if (json.userDataType != null) {
      result._hasUserDataType = true;
      result._userDataType = JsonToString.fromJson(json.userDataType);
    }
    result._items = JsonToList(json.items, UserDataInstance_ObjectListItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUserDataType) {
      result.userDataType = JsonToString.toJson(this._userDataType);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, UserDataInstance_ObjectListItem);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get userDataType() {
    return this._hasUserDataType ? this._userDataType : JsonToString.default;
  }
  get hasUserDataType() {
    return this._hasUserDataType;
  }
  setUserDataType(path, value) {
    return {type: 'SET', path: path.concat(['userDataType']), value};
  }
  deleteUserDataType(path) {
    return {type: 'DELETE', path: path.concat(['userDataType'])};
  }
  /**
   * @returns {UserDataInstance_ObjectListItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, UserDataInstance_ObjectListItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "userDataType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfObjects(this);
              copy._hasUserDataType = true;
              copy._userDataType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUserDataType) {
                return this;
              }
              const copy = new UserDataInstance_ListOfObjects(this);
              copy._hasUserDataType = false;
              copy._userDataType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfObjects(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(UserDataInstance_ObjectListItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new UserDataInstance_ListOfObjects(this);
              copy._items = copy._items.concat([UserDataInstance_ObjectListItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new UserDataInstance_ListOfObjects(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance_ListOfObjects(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = UserDataInstance_ObjectListItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new UserDataInstance_ListOfObjects(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserDataInstance_ListOfObjects(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance_ListOfObjects} other
   * @returns {UserDataInstance_ListOfObjects}
   */
  merge(other) {
    const copy = new UserDataInstance_ListOfObjects(this);
    if (other._hasUserDataType) {
      copy._hasUserDataType = true;
      copy._userDataType = other._userDataType;
    }
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
UserDataInstance_ListOfObjects.default = new UserDataInstance_ListOfObjects();
class UserDataInstance_ListOfObjects_Builder {
  constructor(value) {
    this._value = new UserDataInstance_ListOfObjects(value);
  }
  build() {
    return new UserDataInstance_ListOfObjects(this._value);
  }
  setUserDataType(value) {
    this._value._hasUserDataType = true;
    this._value._userDataType = value;
    return this;
  }
  deleteUserDataType() {
    this._value._hasUserDataType = false;
    this._value._userDataType = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
UserDataInstance_ListOfObjects.Builder = UserDataInstance_ListOfObjects_Builder;
class UserDataInstance_ListOfObjects_WithParent {
  /**
   * @param {UserDataInstance_ListOfObjects} value
   * @param {UserDataInstance_ListOfObjects_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance_ListOfObjects.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUserDataType() {
    if (this._cachedHasUserDataType === undefined) {
      if (this._value.hasUserDataType) {
        this._cachedHasUserDataType = true;
      } else {
        this._cachedHasUserDataType = this._parent ? this._parent.hasUserDataType : false;
      }
    }
    return this._cachedHasUserDataType;
  }
  get userDataType() {
    if (this._cachedUserDataType === undefined) {
      if (this._value.hasUserDataType) {
        this._cachedUserDataType = this._value.userDataType;
      } else {
        this._cachedUserDataType = this._parent ? this._parent.userDataType : this._value.userDataType;
      }
    }
    return this._cachedUserDataType;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new UserDataInstance_ObjectListItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new UserDataInstance_ListOfObjects_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new UserDataInstance_ObjectListItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserDataInstance_ListOfObjects_WithParent.default = new UserDataInstance_ListOfObjects_WithParent(UserDataInstance_ListOfObjects.default, null);
UserDataInstance_ListOfObjects.WithParent = UserDataInstance_ListOfObjects_WithParent;
class UserDataInstance_ListOfObjects_Descriptor {
  get userDataType() {
    if (!this._userDataType) {
      this._userDataType = {
        name: "userDataType",
        Name: "UserDataType",
        number: 1,
        protoType: 9,
        protoName: "user_data_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._userDataType;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 2,
        protoType: 11,
        protoName: "items",
        type: UserDataInstance_ObjectListItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.userDataType,
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUserDataType",
        Name: "DummyOneofForUserDataType",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance_ListOfObjects.descriptor = new UserDataInstance_ListOfObjects_Descriptor();
export class UserDataInstance {
  get descriptor() {
    return UserDataInstance.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._valueTypeCase = 0;
    this._valueTypeValue = null;
  }
  isEmpty() {
    if (this._valueTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataInstance) {
      return value;
    }
    return UserDataInstance.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataInstance();
    if (json.number != null) {
      result._valueTypeCase = 1;
      result._valueTypeValue = UserDataInstance_Number.fromJson(json.number);
    }
    if (json.string != null) {
      result._valueTypeCase = 2;
      result._valueTypeValue = UserDataInstance_String.fromJson(json.string);
    }
    if (json.boolean != null) {
      result._valueTypeCase = 3;
      result._valueTypeValue = UserDataInstance_Boolean.fromJson(json.boolean);
    }
    if (json.listOfNumbers != null) {
      result._valueTypeCase = 4;
      result._valueTypeValue = UserDataInstance_ListOfNumbers.fromJson(json.listOfNumbers);
    }
    if (json.listOfStrings != null) {
      result._valueTypeCase = 5;
      result._valueTypeValue = UserDataInstance_ListOfStrings.fromJson(json.listOfStrings);
    }
    if (json.listOfBooleans != null) {
      result._valueTypeCase = 6;
      result._valueTypeValue = UserDataInstance_ListOfBooleans.fromJson(json.listOfBooleans);
    }
    if (json.object != null) {
      result._valueTypeCase = 7;
      result._valueTypeValue = UserDataInstance_Object.fromJson(json.object);
    }
    if (json.listOfObjects != null) {
      result._valueTypeCase = 8;
      result._valueTypeValue = UserDataInstance_ListOfObjects.fromJson(json.listOfObjects);
    }
    if (json.referencingUserDataValue != null) {
      result._valueTypeCase = 9;
      result._valueTypeValue = JsonToString.fromJson(json.referencingUserDataValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    switch (this._valueTypeCase) {
      case 1:
        result.number = UserDataInstance_Number.toJson(this._valueTypeValue);
        break;
      case 2:
        result.string = UserDataInstance_String.toJson(this._valueTypeValue);
        break;
      case 3:
        result.boolean = UserDataInstance_Boolean.toJson(this._valueTypeValue);
        break;
      case 4:
        result.listOfNumbers = UserDataInstance_ListOfNumbers.toJson(this._valueTypeValue);
        break;
      case 5:
        result.listOfStrings = UserDataInstance_ListOfStrings.toJson(this._valueTypeValue);
        break;
      case 6:
        result.listOfBooleans = UserDataInstance_ListOfBooleans.toJson(this._valueTypeValue);
        break;
      case 7:
        result.object = UserDataInstance_Object.toJson(this._valueTypeValue);
        break;
      case 8:
        result.listOfObjects = UserDataInstance_ListOfObjects.toJson(this._valueTypeValue);
        break;
      case 9:
        result.referencingUserDataValue = JsonToString.toJson(this._valueTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  get valueTypeCase() {
    return this._valueTypeCase;
  }
  deleteValueType(path) {
    switch (this._valueTypeCase) {
      default:
      case 1: {
        return {type: 'DELETE', path: path.concat(['number'])};
      }
      case 2: {
        return {type: 'DELETE', path: path.concat(['string'])};
      }
      case 3: {
        return {type: 'DELETE', path: path.concat(['boolean'])};
      }
      case 4: {
        return {type: 'DELETE', path: path.concat(['listOfNumbers'])};
      }
      case 5: {
        return {type: 'DELETE', path: path.concat(['listOfStrings'])};
      }
      case 6: {
        return {type: 'DELETE', path: path.concat(['listOfBooleans'])};
      }
      case 7: {
        return {type: 'DELETE', path: path.concat(['object'])};
      }
      case 8: {
        return {type: 'DELETE', path: path.concat(['listOfObjects'])};
      }
      case 9: {
        return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
      }
    }
  }
  /**
   * @returns {UserDataInstance_Number}
   */
  get number() {
    return this._valueTypeCase === 1 ? this._valueTypeValue : UserDataInstance_Number.default;
  }
  setNumber(path, value) {
    return {type: 'SET', path: path.concat(['number']), value: value.toJson()};
  }
  deleteNumber(path) {
    return {type: 'DELETE', path: path.concat(['number'])};
  }
  /**
   * @returns {UserDataInstance_String}
   */
  get string() {
    return this._valueTypeCase === 2 ? this._valueTypeValue : UserDataInstance_String.default;
  }
  setString(path, value) {
    return {type: 'SET', path: path.concat(['string']), value: value.toJson()};
  }
  deleteString(path) {
    return {type: 'DELETE', path: path.concat(['string'])};
  }
  /**
   * @returns {UserDataInstance_Boolean}
   */
  get boolean() {
    return this._valueTypeCase === 3 ? this._valueTypeValue : UserDataInstance_Boolean.default;
  }
  setBoolean(path, value) {
    return {type: 'SET', path: path.concat(['boolean']), value: value.toJson()};
  }
  deleteBoolean(path) {
    return {type: 'DELETE', path: path.concat(['boolean'])};
  }
  /**
   * @returns {UserDataInstance_ListOfNumbers}
   */
  get listOfNumbers() {
    return this._valueTypeCase === 4 ? this._valueTypeValue : UserDataInstance_ListOfNumbers.default;
  }
  setListOfNumbers(path, value) {
    return {type: 'SET', path: path.concat(['listOfNumbers']), value: value.toJson()};
  }
  deleteListOfNumbers(path) {
    return {type: 'DELETE', path: path.concat(['listOfNumbers'])};
  }
  /**
   * @returns {UserDataInstance_ListOfStrings}
   */
  get listOfStrings() {
    return this._valueTypeCase === 5 ? this._valueTypeValue : UserDataInstance_ListOfStrings.default;
  }
  setListOfStrings(path, value) {
    return {type: 'SET', path: path.concat(['listOfStrings']), value: value.toJson()};
  }
  deleteListOfStrings(path) {
    return {type: 'DELETE', path: path.concat(['listOfStrings'])};
  }
  /**
   * @returns {UserDataInstance_ListOfBooleans}
   */
  get listOfBooleans() {
    return this._valueTypeCase === 6 ? this._valueTypeValue : UserDataInstance_ListOfBooleans.default;
  }
  setListOfBooleans(path, value) {
    return {type: 'SET', path: path.concat(['listOfBooleans']), value: value.toJson()};
  }
  deleteListOfBooleans(path) {
    return {type: 'DELETE', path: path.concat(['listOfBooleans'])};
  }
  /**
   * @returns {UserDataInstance_Object}
   */
  get object() {
    return this._valueTypeCase === 7 ? this._valueTypeValue : UserDataInstance_Object.default;
  }
  setObject(path, value) {
    return {type: 'SET', path: path.concat(['object']), value: value.toJson()};
  }
  deleteObject(path) {
    return {type: 'DELETE', path: path.concat(['object'])};
  }
  /**
   * @returns {UserDataInstance_ListOfObjects}
   */
  get listOfObjects() {
    return this._valueTypeCase === 8 ? this._valueTypeValue : UserDataInstance_ListOfObjects.default;
  }
  setListOfObjects(path, value) {
    return {type: 'SET', path: path.concat(['listOfObjects']), value: value.toJson()};
  }
  deleteListOfObjects(path) {
    return {type: 'DELETE', path: path.concat(['listOfObjects'])};
  }
  /**
   * @returns {string}
   */
  get referencingUserDataValue() {
    return this._valueTypeCase === 9 ? this._valueTypeValue : JsonToString.default;
  }
  setReferencingUserDataValue(path, value) {
    return {type: 'SET', path: path.concat(['referencingUserDataValue']), value};
  }
  deleteReferencingUserDataValue(path) {
    return {type: 'DELETE', path: path.concat(['referencingUserDataValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "number": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 1;
              copy._valueTypeValue = UserDataInstance_Number.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 1) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 1) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 1;
            copy._valueTypeValue = UserDataInstance_Number.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.number.apply(type, path.slice(1), value);
          if (newValue === this.number) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 1;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "string": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 2;
              copy._valueTypeValue = UserDataInstance_String.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 2) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 2) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 2;
            copy._valueTypeValue = UserDataInstance_String.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.string.apply(type, path.slice(1), value);
          if (newValue === this.string) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 2;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "boolean": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 3;
              copy._valueTypeValue = UserDataInstance_Boolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 3) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 3) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 3;
            copy._valueTypeValue = UserDataInstance_Boolean.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.boolean.apply(type, path.slice(1), value);
          if (newValue === this.boolean) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 3;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "listOfNumbers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 4;
              copy._valueTypeValue = UserDataInstance_ListOfNumbers.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 4) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 4) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 4;
            copy._valueTypeValue = UserDataInstance_ListOfNumbers.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.listOfNumbers.apply(type, path.slice(1), value);
          if (newValue === this.listOfNumbers) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 4;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "listOfStrings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 5;
              copy._valueTypeValue = UserDataInstance_ListOfStrings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 5) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 5) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 5;
            copy._valueTypeValue = UserDataInstance_ListOfStrings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.listOfStrings.apply(type, path.slice(1), value);
          if (newValue === this.listOfStrings) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 5;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "listOfBooleans": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 6;
              copy._valueTypeValue = UserDataInstance_ListOfBooleans.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 6) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 6) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 6;
            copy._valueTypeValue = UserDataInstance_ListOfBooleans.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.listOfBooleans.apply(type, path.slice(1), value);
          if (newValue === this.listOfBooleans) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 6;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "object": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 7;
              copy._valueTypeValue = UserDataInstance_Object.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 7) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 7) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 7;
            copy._valueTypeValue = UserDataInstance_Object.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.object.apply(type, path.slice(1), value);
          if (newValue === this.object) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 7;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "listOfObjects": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 8;
              copy._valueTypeValue = UserDataInstance_ListOfObjects.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 8) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._valueTypeCase !== 8) {
            const copy = new UserDataInstance(this);
            copy._valueTypeCase = 8;
            copy._valueTypeValue = UserDataInstance_ListOfObjects.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.listOfObjects.apply(type, path.slice(1), value);
          if (newValue === this.listOfObjects) {
            return this;
          }
          const copy = new UserDataInstance(this);
          copy._valueTypeCase = 8;
          copy._valueTypeValue = newValue;
          return copy;
        }
      }
      case "referencingUserDataValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 9;
              copy._valueTypeValue = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._valueTypeCase !== 9) {
                return this;
              }
              const copy = new UserDataInstance(this);
              copy._valueTypeCase = 0;
              copy._valueTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataInstance} other
   * @returns {UserDataInstance}
   */
  merge(other) {
    const copy = new UserDataInstance(this);
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      if (this._valueTypeCase === 1) {
        copy._valueTypeValue = copy._valueTypeValue.merge(other._valueTypeValue);
      } else {
        copy._valueTypeValue = other._valueTypeValue;
      }
      copy._valueTypeCase = 1;
    }
    if (other._valueTypeCase === 1) {
      copy._valueTypeCase = 1;
      copy._valueTypeValue = other._valueTypeValue;
    }
    return copy;
  }
}
UserDataInstance.default = new UserDataInstance();
UserDataInstance.Number = UserDataInstance_Number;
UserDataInstance.String = UserDataInstance_String;
UserDataInstance.Boolean = UserDataInstance_Boolean;
UserDataInstance.ListOfNumbers = UserDataInstance_ListOfNumbers;
UserDataInstance.ListOfStrings = UserDataInstance_ListOfStrings;
UserDataInstance.ListOfBooleans = UserDataInstance_ListOfBooleans;
UserDataInstance.ObjectProperty = UserDataInstance_ObjectProperty;
UserDataInstance.ObjectData = UserDataInstance_ObjectData;
UserDataInstance.Object = UserDataInstance_Object;
UserDataInstance.ObjectListItem = UserDataInstance_ObjectListItem;
UserDataInstance.ListOfObjects = UserDataInstance_ListOfObjects;
class UserDataInstance_Builder {
  constructor(value) {
    this._value = new UserDataInstance(value);
  }
  build() {
    return new UserDataInstance(this._value);
  }
  clearvalueType() {
    this._value._valueTypeCase = 0;
    this._value._valueTypeValue = null;
    return this;
  }
  setNumber(value) {
    this._value._valueTypeCase = 1;
    this._value._valueTypeValue = value;
    return this;
  }
  setString(value) {
    this._value._valueTypeCase = 2;
    this._value._valueTypeValue = value;
    return this;
  }
  setBoolean(value) {
    this._value._valueTypeCase = 3;
    this._value._valueTypeValue = value;
    return this;
  }
  setListOfNumbers(value) {
    this._value._valueTypeCase = 4;
    this._value._valueTypeValue = value;
    return this;
  }
  setListOfStrings(value) {
    this._value._valueTypeCase = 5;
    this._value._valueTypeValue = value;
    return this;
  }
  setListOfBooleans(value) {
    this._value._valueTypeCase = 6;
    this._value._valueTypeValue = value;
    return this;
  }
  setObject(value) {
    this._value._valueTypeCase = 7;
    this._value._valueTypeValue = value;
    return this;
  }
  setListOfObjects(value) {
    this._value._valueTypeCase = 8;
    this._value._valueTypeValue = value;
    return this;
  }
  setReferencingUserDataValue(value) {
    this._value._valueTypeCase = 9;
    this._value._valueTypeValue = value;
    return this;
  }
}
UserDataInstance.Builder = UserDataInstance_Builder;
class UserDataInstance_WithParent {
  /**
   * @param {UserDataInstance} value
   * @param {UserDataInstance_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataInstance.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get valueTypeCase() {
    if (this._cachedvalueTypeCase === undefined) {
      if (this._value._valueTypeCase === 0) {
        this._cachedvalueTypeCase = this._parent ? this._parent.valueTypeCase : 0;
      } else {
        this._cachedvalueTypeCase = this._value._valueTypeCase;
      }
    }
    return this._cachedvalueTypeCase;
  }
  get number() {
    if (!this._cachedNumber) {
      if (this._value._valueTypeCase === 0) {
        this._cachedNumber = this._parent ? new UserDataInstance_Number.WithParent(UserDataInstance_Number.default, this._parent.number) : this._value.number;
      } else if (this._value._valueTypeCase === 1) {
        this._cachedNumber = new UserDataInstance_Number.WithParent(this._value.number, this._parent && this._parent.valueTypeCase === 1 ? this._parent.number : null);
      } else {
        this._cachedNumber = UserDataInstance_Number.WithParent.default;
      }
    }
    return this._cachedNumber;
  }
  get string() {
    if (!this._cachedString) {
      if (this._value._valueTypeCase === 0) {
        this._cachedString = this._parent ? new UserDataInstance_String.WithParent(UserDataInstance_String.default, this._parent.string) : this._value.string;
      } else if (this._value._valueTypeCase === 2) {
        this._cachedString = new UserDataInstance_String.WithParent(this._value.string, this._parent && this._parent.valueTypeCase === 2 ? this._parent.string : null);
      } else {
        this._cachedString = UserDataInstance_String.WithParent.default;
      }
    }
    return this._cachedString;
  }
  get boolean() {
    if (!this._cachedBoolean) {
      if (this._value._valueTypeCase === 0) {
        this._cachedBoolean = this._parent ? new UserDataInstance_Boolean.WithParent(UserDataInstance_Boolean.default, this._parent.boolean) : this._value.boolean;
      } else if (this._value._valueTypeCase === 3) {
        this._cachedBoolean = new UserDataInstance_Boolean.WithParent(this._value.boolean, this._parent && this._parent.valueTypeCase === 3 ? this._parent.boolean : null);
      } else {
        this._cachedBoolean = UserDataInstance_Boolean.WithParent.default;
      }
    }
    return this._cachedBoolean;
  }
  get listOfNumbers() {
    if (!this._cachedListOfNumbers) {
      if (this._value._valueTypeCase === 0) {
        this._cachedListOfNumbers = this._parent ? new UserDataInstance_ListOfNumbers.WithParent(UserDataInstance_ListOfNumbers.default, this._parent.listOfNumbers) : this._value.listOfNumbers;
      } else if (this._value._valueTypeCase === 4) {
        this._cachedListOfNumbers = new UserDataInstance_ListOfNumbers.WithParent(this._value.listOfNumbers, this._parent && this._parent.valueTypeCase === 4 ? this._parent.listOfNumbers : null);
      } else {
        this._cachedListOfNumbers = UserDataInstance_ListOfNumbers.WithParent.default;
      }
    }
    return this._cachedListOfNumbers;
  }
  get listOfStrings() {
    if (!this._cachedListOfStrings) {
      if (this._value._valueTypeCase === 0) {
        this._cachedListOfStrings = this._parent ? new UserDataInstance_ListOfStrings.WithParent(UserDataInstance_ListOfStrings.default, this._parent.listOfStrings) : this._value.listOfStrings;
      } else if (this._value._valueTypeCase === 5) {
        this._cachedListOfStrings = new UserDataInstance_ListOfStrings.WithParent(this._value.listOfStrings, this._parent && this._parent.valueTypeCase === 5 ? this._parent.listOfStrings : null);
      } else {
        this._cachedListOfStrings = UserDataInstance_ListOfStrings.WithParent.default;
      }
    }
    return this._cachedListOfStrings;
  }
  get listOfBooleans() {
    if (!this._cachedListOfBooleans) {
      if (this._value._valueTypeCase === 0) {
        this._cachedListOfBooleans = this._parent ? new UserDataInstance_ListOfBooleans.WithParent(UserDataInstance_ListOfBooleans.default, this._parent.listOfBooleans) : this._value.listOfBooleans;
      } else if (this._value._valueTypeCase === 6) {
        this._cachedListOfBooleans = new UserDataInstance_ListOfBooleans.WithParent(this._value.listOfBooleans, this._parent && this._parent.valueTypeCase === 6 ? this._parent.listOfBooleans : null);
      } else {
        this._cachedListOfBooleans = UserDataInstance_ListOfBooleans.WithParent.default;
      }
    }
    return this._cachedListOfBooleans;
  }
  get object() {
    if (!this._cachedObject) {
      if (this._value._valueTypeCase === 0) {
        this._cachedObject = this._parent ? new UserDataInstance_Object.WithParent(UserDataInstance_Object.default, this._parent.object) : this._value.object;
      } else if (this._value._valueTypeCase === 7) {
        this._cachedObject = new UserDataInstance_Object.WithParent(this._value.object, this._parent && this._parent.valueTypeCase === 7 ? this._parent.object : null);
      } else {
        this._cachedObject = UserDataInstance_Object.WithParent.default;
      }
    }
    return this._cachedObject;
  }
  get listOfObjects() {
    if (!this._cachedListOfObjects) {
      if (this._value._valueTypeCase === 0) {
        this._cachedListOfObjects = this._parent ? new UserDataInstance_ListOfObjects.WithParent(UserDataInstance_ListOfObjects.default, this._parent.listOfObjects) : this._value.listOfObjects;
      } else if (this._value._valueTypeCase === 8) {
        this._cachedListOfObjects = new UserDataInstance_ListOfObjects.WithParent(this._value.listOfObjects, this._parent && this._parent.valueTypeCase === 8 ? this._parent.listOfObjects : null);
      } else {
        this._cachedListOfObjects = UserDataInstance_ListOfObjects.WithParent.default;
      }
    }
    return this._cachedListOfObjects;
  }
  get referencingUserDataValue() {
    if (!this._cachedReferencingUserDataValue) {
      if (this._value._valueTypeCase === 0) {
        this._cachedReferencingUserDataValue = this._parent ? this._parent.referencingUserDataValue : this._value.referencingUserDataValue;
      } else {
        this._cachedReferencingUserDataValue = this._value.referencingUserDataValue;
      }
    }
    return this._cachedReferencingUserDataValue;
  }
  update(current, parent) {
    const result = new UserDataInstance_WithParent(current, parent);
    if (this._cachedNumber && this._value._valueTypeCase === 1 && current._valueTypeCase === 1) {
      if (this._value.number === current.number && this._parent === parent) {
        result._cachedNumber = this._cachedNumber;
      } else {
        result._cachedNumber = this._cachedNumber.update(current.number, parent && parent.valueTypeCase === 1 ? parent.number : null);
      }
    }
    if (this._cachedString && this._value._valueTypeCase === 2 && current._valueTypeCase === 2) {
      if (this._value.string === current.string && this._parent === parent) {
        result._cachedString = this._cachedString;
      } else {
        result._cachedString = this._cachedString.update(current.string, parent && parent.valueTypeCase === 2 ? parent.string : null);
      }
    }
    if (this._cachedBoolean && this._value._valueTypeCase === 3 && current._valueTypeCase === 3) {
      if (this._value.boolean === current.boolean && this._parent === parent) {
        result._cachedBoolean = this._cachedBoolean;
      } else {
        result._cachedBoolean = this._cachedBoolean.update(current.boolean, parent && parent.valueTypeCase === 3 ? parent.boolean : null);
      }
    }
    if (this._cachedListOfNumbers && this._value._valueTypeCase === 4 && current._valueTypeCase === 4) {
      if (this._value.listOfNumbers === current.listOfNumbers && this._parent === parent) {
        result._cachedListOfNumbers = this._cachedListOfNumbers;
      } else {
        result._cachedListOfNumbers = this._cachedListOfNumbers.update(current.listOfNumbers, parent && parent.valueTypeCase === 4 ? parent.listOfNumbers : null);
      }
    }
    if (this._cachedListOfStrings && this._value._valueTypeCase === 5 && current._valueTypeCase === 5) {
      if (this._value.listOfStrings === current.listOfStrings && this._parent === parent) {
        result._cachedListOfStrings = this._cachedListOfStrings;
      } else {
        result._cachedListOfStrings = this._cachedListOfStrings.update(current.listOfStrings, parent && parent.valueTypeCase === 5 ? parent.listOfStrings : null);
      }
    }
    if (this._cachedListOfBooleans && this._value._valueTypeCase === 6 && current._valueTypeCase === 6) {
      if (this._value.listOfBooleans === current.listOfBooleans && this._parent === parent) {
        result._cachedListOfBooleans = this._cachedListOfBooleans;
      } else {
        result._cachedListOfBooleans = this._cachedListOfBooleans.update(current.listOfBooleans, parent && parent.valueTypeCase === 6 ? parent.listOfBooleans : null);
      }
    }
    if (this._cachedObject && this._value._valueTypeCase === 7 && current._valueTypeCase === 7) {
      if (this._value.object === current.object && this._parent === parent) {
        result._cachedObject = this._cachedObject;
      } else {
        result._cachedObject = this._cachedObject.update(current.object, parent && parent.valueTypeCase === 7 ? parent.object : null);
      }
    }
    if (this._cachedListOfObjects && this._value._valueTypeCase === 8 && current._valueTypeCase === 8) {
      if (this._value.listOfObjects === current.listOfObjects && this._parent === parent) {
        result._cachedListOfObjects = this._cachedListOfObjects;
      } else {
        result._cachedListOfObjects = this._cachedListOfObjects.update(current.listOfObjects, parent && parent.valueTypeCase === 8 ? parent.listOfObjects : null);
      }
    }
    return result;
  }
}
UserDataInstance_WithParent.default = new UserDataInstance_WithParent(UserDataInstance.default, null);
UserDataInstance.WithParent = UserDataInstance_WithParent;
class UserDataInstance_Descriptor {
  get number() {
    if (!this._number) {
      this._number = {
        name: "number",
        Name: "Number",
        number: 1,
        protoType: 11,
        protoName: "number",
        oneofIndex: 0,
        type: UserDataInstance_Number,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._number;
  }
  get string() {
    if (!this._string) {
      this._string = {
        name: "string",
        Name: "String",
        number: 2,
        protoType: 11,
        protoName: "string",
        oneofIndex: 0,
        type: UserDataInstance_String,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._string;
  }
  get boolean() {
    if (!this._boolean) {
      this._boolean = {
        name: "boolean",
        Name: "Boolean",
        number: 3,
        protoType: 11,
        protoName: "boolean",
        oneofIndex: 0,
        type: UserDataInstance_Boolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._boolean;
  }
  get listOfNumbers() {
    if (!this._listOfNumbers) {
      this._listOfNumbers = {
        name: "listOfNumbers",
        Name: "ListOfNumbers",
        number: 4,
        protoType: 11,
        protoName: "list_of_numbers",
        oneofIndex: 0,
        type: UserDataInstance_ListOfNumbers,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._listOfNumbers;
  }
  get listOfStrings() {
    if (!this._listOfStrings) {
      this._listOfStrings = {
        name: "listOfStrings",
        Name: "ListOfStrings",
        number: 5,
        protoType: 11,
        protoName: "list_of_strings",
        oneofIndex: 0,
        type: UserDataInstance_ListOfStrings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._listOfStrings;
  }
  get listOfBooleans() {
    if (!this._listOfBooleans) {
      this._listOfBooleans = {
        name: "listOfBooleans",
        Name: "ListOfBooleans",
        number: 6,
        protoType: 11,
        protoName: "list_of_booleans",
        oneofIndex: 0,
        type: UserDataInstance_ListOfBooleans,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._listOfBooleans;
  }
  get object() {
    if (!this._object) {
      this._object = {
        name: "object",
        Name: "Object",
        number: 7,
        protoType: 11,
        protoName: "object",
        oneofIndex: 0,
        type: UserDataInstance_Object,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._object;
  }
  get listOfObjects() {
    if (!this._listOfObjects) {
      this._listOfObjects = {
        name: "listOfObjects",
        Name: "ListOfObjects",
        number: 8,
        protoType: 11,
        protoName: "list_of_objects",
        oneofIndex: 0,
        type: UserDataInstance_ListOfObjects,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._listOfObjects;
  }
  get referencingUserDataValue() {
    if (!this._referencingUserDataValue) {
      this._referencingUserDataValue = {
        name: "referencingUserDataValue",
        Name: "ReferencingUserDataValue",
        number: 9,
        protoType: 9,
        protoName: "referencing_user_data_value",
        oneofIndex: 0,
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._referencingUserDataValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.number,
        this.string,
        this.boolean,
        this.listOfNumbers,
        this.listOfStrings,
        this.listOfBooleans,
        this.object,
        this.listOfObjects,
        this.referencingUserDataValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "valueType",
        Name: "ValueType",
        fields: [
          this.fields[0],
          this.fields[1],
          this.fields[2],
          this.fields[3],
          this.fields[4],
          this.fields[5],
          this.fields[6],
          this.fields[7],
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
UserDataInstance.descriptor = new UserDataInstance_Descriptor();
class UserDataValue_InstancesEntry {
  get descriptor() {
    return UserDataValue_InstancesEntry.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasValue = false;
    this._value = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasValue && !this._value.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataValue_InstancesEntry) {
      return value;
    }
    return UserDataValue_InstancesEntry.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataValue_InstancesEntry();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.value != null) {
      result._hasValue = true;
      result._value = UserDataInstance.fromJson(json.value);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasValue && !this._value.isEmpty()) {
      result.value = UserDataInstance.toJson(this._value);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {UserDataInstance}
   */
  get value() {
    return this._hasValue ? this._value : UserDataInstance.default;
  }
  get hasValue() {
    return this._hasValue;
  }
  setValue(path, value) {
    return {type: 'SET', path: path.concat(['value']), value: value.toJson()};
  }
  deleteValue(path) {
    return {type: 'DELETE', path: path.concat(['value'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataValue_InstancesEntry(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new UserDataValue_InstancesEntry(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "value": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataValue_InstancesEntry(this);
              copy._hasValue = true;
              copy._value = UserDataInstance.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasValue) {
                return this;
              }
              const copy = new UserDataValue_InstancesEntry(this);
              copy._hasValue = false;
              copy._value = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasValue) {
            const copy = new UserDataValue_InstancesEntry(this);
            copy._hasValue = true;
            copy._value = UserDataInstance.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._value.apply(type, path.slice(1), value);
          if (newValue === this._value) {
            return this;
          }
          const copy = new UserDataValue_InstancesEntry(this);
          copy._value = copy._value.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataValue_InstancesEntry} other
   * @returns {UserDataValue_InstancesEntry}
   */
  merge(other) {
    const copy = new UserDataValue_InstancesEntry(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasValue) {
      if (copy._hasValue) {
        copy._value = copy.value.merge(other.value);
      } else {
        copy._value = other._value;
      }
      copy._hasValue = true;
    }
    return copy;
  }
}
UserDataValue_InstancesEntry.default = new UserDataValue_InstancesEntry();
class UserDataValue_InstancesEntry_Builder {
  constructor(value) {
    this._value = new UserDataValue_InstancesEntry(value);
  }
  build() {
    return new UserDataValue_InstancesEntry(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setValue(value) {
    this._value._hasValue = true;
    this._value._value = value;
    return this;
  }
  deleteValue() {
    this._value._hasValue = false;
    this._value._value = null;
    return this;
  }
}
UserDataValue_InstancesEntry.Builder = UserDataValue_InstancesEntry_Builder;
class UserDataValue_InstancesEntry_WithParent {
  /**
   * @param {UserDataValue_InstancesEntry} value
   * @param {UserDataValue_InstancesEntry_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataValue_InstancesEntry.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasValue() {
    if (this._cachedHasValue === undefined) {
      if (this._value.hasValue) {
        this._cachedHasValue = true;
      } else {
        this._cachedHasValue = this._parent ? this._parent.hasValue : false;
      }
    }
    return this._cachedHasValue;
  }
  get value() {
    if (!this._cachedValue) {
      if (this._value.hasValue) {
        this._cachedValue = new UserDataInstance.WithParent(this._value.value, this._parent && this._parent.hasValue ? this._parent.value : null);
      } else {
        this._cachedValue = this._parent ? new UserDataInstance.WithParent(UserDataInstance.default, this._parent.value) : UserDataInstance.WithParent.default;
      }
    }
    return this._cachedValue;
  }
  update(current, parent) {
    const result = new UserDataValue_InstancesEntry_WithParent(current, parent);
    if (this._cachedValue && this._value.hasValue && current.hasValue) {
      if (this._value.value === current.value && this._parent === parent) {
        result._cachedValue = this._cachedValue;
      } else {
        result._cachedValue = this._cachedValue.update(current.value, parent && parent.hasValue ? parent.value : null);
      }
    }
    return result;
  }
}
UserDataValue_InstancesEntry_WithParent.default = new UserDataValue_InstancesEntry_WithParent(UserDataValue_InstancesEntry.default, null);
UserDataValue_InstancesEntry.WithParent = UserDataValue_InstancesEntry_WithParent;
class UserDataValue_InstancesEntry_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get value() {
    if (!this._value) {
      this._value = {
        name: "value",
        Name: "Value",
        number: 2,
        protoType: 11,
        protoName: "value",
        type: UserDataInstance,
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._value;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.value,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UserDataValue_InstancesEntry.descriptor = new UserDataValue_InstancesEntry_Descriptor();
export class UserDataValue {
  get descriptor() {
    return UserDataValue.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._instances = {};
  }
  isEmpty() {
    if (Object.keys(this._instances).length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UserDataValue) {
      return value;
    }
    return UserDataValue.fromJson(value);
  }
  static fromJson(json) {
    const result = new UserDataValue();
    result._instances = JsonToMap(json.instances, JsonToString, UserDataInstance);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (Object.keys(this._instances).length > 0) {
      result.instances = MapToJson(this._instances, JsonToString, UserDataInstance);
    }
    return result;
  }
  /**
   * @returns {Object<string, UserDataInstance>}
   */
  get instances() {
    return this._instances;
  }
  setInstances(path, value) {
    return {type: 'SET', path: path.concat(['instances']), value: MapToJson(value, JsonToString, UserDataInstance)};
  }
  setInstancesByKey(path, key, value) {
    return {type: 'SET', path: path.concat(['instances', key]), value: value.toJson()};
  }
  deleteInstances(path) {
    return {type: 'DELETE', path: path.concat(['instances'])};
  }
  deleteInstancesByKey(path, key) {
    return {type: 'DELETE', path: path.concat(['instances', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "instances": {
        if (path.length === 1) {
          switch (type) {
            case 'DELETE': {
              if (Object.keys(this._instances).length === 0) {
                return this;
              }
              const copy = new UserDataValue(this);
              copy._instances = {};
              return copy;
            }
            case 'SET': {
              const copy = new UserDataValue(this);
              copy._instances = {};
              for (let key in value) {
                copy._instances[key] = UserDataInstance.fromAny(value[key]);
              }
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          switch (type) {
            case 'SET': {
              const copy = new UserDataValue(this);
              copy._instances = {...copy._instances};
              copy._instances[path[1]] = UserDataInstance.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._instances[path[1]]) {
                return this;
              }
              const copy = new UserDataValue(this);
              copy._instances = {...copy._instances};
              delete copy._instances[path[1]];
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (this._instances[key] === undefined) {
            const copy = new UserDataValue(this);
            copy._instances = {...copy._instances};
            copy._instances[key] = UserDataInstance.default.apply(type, path.slice(2), value);
            return copy;
          }
          const oldValue = this._instances[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new UserDataValue(this);
          copy._instances = {...copy._instances};
          copy._instances[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UserDataValue} other
   * @returns {UserDataValue}
   */
  merge(other) {
    const copy = new UserDataValue(this);
    copy._instances = {...this._instances, ...other._instances};
    return copy;
  }
}
UserDataValue.default = new UserDataValue();
UserDataValue.InstancesEntry = UserDataValue_InstancesEntry;
class UserDataValue_Builder {
  constructor(value) {
    this._value = new UserDataValue(value);
  }
  build() {
    return new UserDataValue(this._value);
  }
  setInstances(key, value) {
    this._value._instances = {...this._value._instances, [key]: value};
    return this;
  }
  addAllInstances(values) {
    this._value._instances = {...this._value._instances, ...values};
    return this;
  }
  deleteInstances(key) {
    this._value._instances = {...this._value._instances};
    delete this._value._instances[key];
    return this;
  }
  clearInstances() {
    this._value._instances = {};
    return this;
  }
}
UserDataValue.Builder = UserDataValue_Builder;
class UserDataValue_WithParent {
  /**
   * @param {UserDataValue} value
   * @param {UserDataValue_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UserDataValue.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfInstances() {
    if (!this._selfInstances) {
      this._selfInstances = {};
      for (let i in this._value.instances) {
        this._selfInstances[i] = new UserDataInstance.WithParent(this._value.instances[i], null);
      }
    }
    return this._selfInstances;
  }
  get inherentInstances() {
    if (!this._inherentInstances) {
      this._inherentInstances = this._parent ? this._parent.instances : {};
    }
    return this._inherentInstances;
  }
  get instances() {
    if (!this._allInstances) {
      this._allInstances = this._parent ? {...this._parent.instances, ...this.selfInstances} : this.selfInstances;
    }
    return this._allInstances;
  }
  update(current, parent) {
    const result = new UserDataValue_WithParent(current, parent);
    if (this._selfInstances) {
      if (this._value.instances === current.instances) {
        result._selfInstances = this._selfInstances;
      } else {
        result._selfInstances = {};
        for (let i in current.instances) {
          const oldValue = this._value.instances[i];
          if (oldValue) {
            const oldCache = this._selfInstances[i];
            if (oldValue === current.instances[i]) {
              result._selfInstances[i] = oldCache;
            } else {
              result._selfInstances[i] = oldCache.update(current.instances[i], null);
            }
          } else {
            result._selfInstances[i] = new UserDataInstance.WithParent(current.instances[i], null);
          }
        }
      }
    }
    return result;
  }
}
UserDataValue_WithParent.default = new UserDataValue_WithParent(UserDataValue.default, null);
UserDataValue.WithParent = UserDataValue_WithParent;
class UserDataValue_Descriptor {
  get instances() {
    if (!this._instances) {
      this._instances = {
        name: "instances",
        Name: "Instances",
        number: 1,
        protoType: 11,
        protoName: "instances",
        isMap: true,
        keyType: JsonToString,
        valueType: UserDataInstance,
        keyProtoType: 9,
        valueProtoType: 11,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._instances;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.instances,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
UserDataValue.descriptor = new UserDataValue_Descriptor();
